import React, { useEffect, useMemo, useRef, useState } from "react";
import api from "../api";
import PaginationBar from "../components/PaginationBar";
import UserHistoryDialog from "../components/UserHistoryDialog";
import ReferralAdminTab from "../components/ReferralAdminTab";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Switch } from "../components/ui/switch";
import { Textarea } from "../components/ui/textarea";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "../components/ui/dialog";
import { toast } from "sonner";
import { Plus, Trash2, FileBadge, Sparkles, BarChart3, CheckCircle2, XCircle, Eye, ListChecks, Users as UsersIcon, Calendar as CalIcon, ShieldOff, MessageSquareText, Mail, MailCheck, ScrollText, Reply, Star, FileText, Edit3, Copy, Download, FileSpreadsheet, Search, Flag, RefreshCw, Send, Banknote, CornerUpLeft, MapPin, FlaskConical, Bell, Activity, AlertCircle, AlertTriangle, Gift } from "lucide-react";
import { LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { toPng } from "html-to-image";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";

export default function AdminPanel() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6" style={{ fontFamily: "Outfit" }}>Tableau de bord administrateur</h1>
      <Tabs defaultValue="stats">
        <TabsList className="tabs-scroll bg-slate-100 p-1 rounded-xl mb-4">
          <TabsTrigger value="stats" data-testid="adm-tab-stats"><BarChart3 className="w-4 h-4 mr-1" />Statistiques</TabsTrigger>
          <TabsTrigger value="bookings" data-testid="adm-tab-bookings"><ListChecks className="w-4 h-4 mr-1" />Réservations</TabsTrigger>
          <TabsTrigger value="slots" data-testid="adm-tab-slots"><CalIcon className="w-4 h-4 mr-1" />Créneaux en ligne</TabsTrigger>
          <TabsTrigger value="users" data-testid="adm-tab-users"><UsersIcon className="w-4 h-4 mr-1" />Utilisateurs</TabsTrigger>
          <TabsTrigger value="diplomas" data-testid="adm-tab-diplomas"><FileBadge className="w-4 h-4 mr-1" />Documents MNS</TabsTrigger>
          <TabsTrigger value="reviews" data-testid="adm-tab-reviews"><MessageSquareText className="w-4 h-4 mr-1" />Avis plateforme</TabsTrigger>
          <TabsTrigger value="contact" data-testid="adm-tab-contact"><Mail className="w-4 h-4 mr-1" />Contact</TabsTrigger>
          <TabsTrigger value="emails" data-testid="adm-tab-emails"><MailCheck className="w-4 h-4 mr-1" />Délivrabilité</TabsTrigger>
          <TabsTrigger value="connect" data-testid="adm-tab-connect"><Banknote className="w-4 h-4 mr-1" />Stripe Connect</TabsTrigger>
          <TabsTrigger value="audit" data-testid="adm-tab-audit"><ScrollText className="w-4 h-4 mr-1" />Journal d'audit</TabsTrigger>
          <TabsTrigger value="sanctions" data-testid="adm-tab-sanctions"><ShieldOff className="w-4 h-4 mr-1" />Sanctions</TabsTrigger>
          <TabsTrigger value="reports" data-testid="adm-tab-reports"><Flag className="w-4 h-4 mr-1" />Signalements</TabsTrigger>
          <TabsTrigger value="poolsug" data-testid="adm-tab-poolsug"><MapPin className="w-4 h-4 mr-1" />Suggestions piscines</TabsTrigger>
          <TabsTrigger value="legal" data-testid="adm-tab-legal"><FileText className="w-4 h-4 mr-1" />Contenus légaux</TabsTrigger>
          <TabsTrigger value="options" data-testid="adm-tab-options"><Sparkles className="w-4 h-4 mr-1" />Options payantes</TabsTrigger>
          <TabsTrigger value="tests" data-testid="adm-tab-tests"><FlaskConical className="w-4 h-4 mr-1" />Tests Emergent</TabsTrigger>
          <TabsTrigger value="subs" data-testid="adm-tab-subs"><FileBadge className="w-4 h-4 mr-1" />Abonnements</TabsTrigger>
          <TabsTrigger value="referral" data-testid="adm-tab-referral"><Gift className="w-4 h-4 mr-1" />Parrainage</TabsTrigger>
          <TabsTrigger value="health" data-testid="adm-tab-health"><Activity className="w-4 h-4 mr-1" />État système</TabsTrigger>
        </TabsList>
        <TabsContent value="stats"><StatsTab /></TabsContent>
        <TabsContent value="bookings"><BookingsTab /></TabsContent>
        <TabsContent value="slots"><SlotsTab /></TabsContent>
        <TabsContent value="users"><UsersTab /></TabsContent>
        <TabsContent value="diplomas"><DocsTab /></TabsContent>
        <TabsContent value="reviews"><AppReviewsAdminTab /></TabsContent>
        <TabsContent value="contact"><ContactAdminTab /></TabsContent>
        <TabsContent value="emails"><EmailDeliverabilityTab /></TabsContent>
        <TabsContent value="connect"><ConnectAdminTab /></TabsContent>
        <TabsContent value="audit"><AuditLogTab /></TabsContent>
        <TabsContent value="sanctions"><SanctionsTab /></TabsContent>
        <TabsContent value="reports"><ReportsAdminTab /></TabsContent>
        <TabsContent value="poolsug"><PoolSuggestionsAdminTab /></TabsContent>
        <TabsContent value="legal"><LegalAdminTab /></TabsContent>
        <TabsContent value="options"><OptionsTab /></TabsContent>
        <TabsContent value="tests"><TestsEmergentTab /></TabsContent>
        <TabsContent value="subs"><SubscriptionsAdminTab /></TabsContent>
        <TabsContent value="referral"><ReferralAdminTab /></TabsContent>
        <TabsContent value="health"><SystemHealthTab /></TabsContent>
      </Tabs>
    </div>
  );
}

function PoolSuggestionsAdminTab() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("pending");
  const [loading, setLoading] = useState(true);

  const reload = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/admin/pool-suggestions${status ? `?status=${status}` : ""}`);
      setItems(data || []);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Chargement impossible");
    } finally { setLoading(false); }
  };
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, [status]);

  const approve = async (sid, label) => {
    try {
      await api.post(`/admin/pool-suggestions/${sid}/approve`);
      toast.success(`Modification appliquée pour ${label}`);
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };
  const reject = async (sid, label) => {
    const reason = window.prompt(`Motif du refus (optionnel) — ${label} :`, "");
    if (reason === null) return;
    try {
      await api.post(`/admin/pool-suggestions/${sid}/reject`, { reason });
      toast.success("Suggestion refusée");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  const renderDiff = (sug) => {
    const before = sug.before || {};
    const diff = sug.diff || {};
    const keys = Object.keys(diff);
    if (!keys.length) return <span className="text-slate-500 text-xs">Aucun champ modifié</span>;
    return (
      <table className="text-xs w-full">
        <tbody>
          {keys.map((k) => (
            <tr key={k} className="border-b border-slate-100">
              <td className="py-1 pr-2 font-semibold text-slate-700 capitalize">{k}</td>
              <td className="py-1 pr-2 text-red-600 line-through">{String(before[k] ?? "—")}</td>
              <td className="py-1 text-emerald-700 font-medium">{String(diff[k])}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div className="space-y-4" data-testid="adm-pool-suggestions">
      <div className="flex items-center gap-2 flex-wrap">
        <Label className="text-sm">Statut</Label>
        {["pending", "approved", "rejected", ""].map((s) => (
          <Button key={s || "all"} size="sm" variant={status === s ? "default" : "outline"}
            onClick={() => setStatus(s)} className="rounded-full"
            data-testid={`poolsug-filter-${s || "all"}`}>
            {s === "pending" ? "En attente" : s === "approved" ? "Approuvées" : s === "rejected" ? "Refusées" : "Toutes"}
          </Button>
        ))}
        <Button size="sm" variant="outline" className="rounded-full ml-auto" onClick={reload} data-testid="poolsug-refresh">
          <RefreshCw className="w-3.5 h-3.5 mr-1" />Rafraîchir
        </Button>
      </div>
      {loading ? <div className="text-slate-500">Chargement…</div> : items.length === 0 ? (
        <div className="card-soft p-8 text-center text-slate-500" data-testid="poolsug-empty">
          Aucune suggestion {status === "pending" ? "en attente" : status === "approved" ? "approuvée" : status === "rejected" ? "refusée" : ""}.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((sug) => (
            <div key={sug.suggestion_id} className="card-soft p-4" data-testid={`poolsug-item-${sug.suggestion_id}`}>
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div>
                  <div className="font-semibold text-slate-900 flex items-center gap-2">
                    <MapPin className="w-4 h-4 text-sky-700" />
                    {sug.pool_name || sug.pool?.name || sug.pool_id}
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5">
                    Par <strong>{sug.user_name}</strong> ({sug.user_email}) · {new Date(sug.created_at).toLocaleString("fr-FR")}
                  </div>
                  {sug.reason && (
                    <div className="text-sm text-slate-700 mt-1 italic">"{sug.reason}"</div>
                  )}
                </div>
                <span className={`text-[11px] px-2 py-0.5 rounded-full ${sug.status === "pending" ? "bg-amber-100 text-amber-800" : sug.status === "approved" ? "bg-emerald-100 text-emerald-800" : "bg-slate-200 text-slate-700"}`}>
                  {sug.status === "pending" ? "En attente" : sug.status === "approved" ? "Approuvée" : "Refusée"}
                </span>
              </div>
              <div className="mt-3 bg-slate-50 rounded-lg p-3">
                {renderDiff(sug)}
              </div>
              {sug.status === "rejected" && sug.rejection_reason && (
                <p className="mt-2 text-xs text-red-700">Motif : {sug.rejection_reason}</p>
              )}
              {sug.status === "pending" && (
                <div className="mt-3 flex gap-2 justify-end">
                  <Button size="sm" variant="outline" className="rounded-full"
                    onClick={() => reject(sug.suggestion_id, sug.pool_name)}
                    data-testid={`poolsug-reject-${sug.suggestion_id}`}>
                    <XCircle className="w-3.5 h-3.5 mr-1" />Refuser
                  </Button>
                  <Button size="sm" className="rounded-full bg-emerald-600 hover:bg-emerald-500"
                    onClick={() => approve(sug.suggestion_id, sug.pool_name)}
                    data-testid={`poolsug-approve-${sug.suggestion_id}`}>
                    <CheckCircle2 className="w-3.5 h-3.5 mr-1" />Approuver et appliquer
                  </Button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function ReportsAdminTab() {
  const [list, setList] = useState([]);
  const [status, setStatus] = useState("pending");
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);

  const reload = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/reports", { params: status === "all" ? {} : { status } });
      setList(data || []);
      setPage(0);
    } finally { setLoading(false); }
  };
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, [status]);

  const resolve = async (id) => {
    try {
      await api.post(`/admin/reports/${id}/resolve`);
      toast.success("Signalement résolu");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  const unresolve = async (id) => {
    try {
      await api.post(`/admin/reports/${id}/unresolve`);
      toast.success("Signalement ré-ouvert");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  /** Pick the right internal URL depending on target type.
   *  - user + role=mns  → public MNS profile (/mns/{id})
   *  - user + role=client → admin user detail (/admin?q=email&tab=users)
   *  - pool             → public pool page (/pool/{id})
   */
  const targetUrl = (r) => {
    if (r.target_type === "pool") return `/pool/${r.target_id}`;
    if (r.target_type === "user") {
      if (r.target_role === "mns") return `/mns/${r.target_id}`;
      // Client: no public profile → send admin to the users tab, pre-filtered
      return `/admin?tab=users&q=${encodeURIComponent(r.target_email || r.target_id)}`;
    }
    return "#";
  };

  const reasonLabel = (r) => ({
    fraud: "Fraude / faux profil",
    inappropriate: "Comportement inapproprié",
    safety: "Risque pour la sécurité",
    qualification: "Diplôme douteux",
    wrong_info: "Informations incorrectes",
    closed: "Établissement fermé",
    duplicate: "Doublon",
    other: "Autre",
  }[r] || r);

  return (
    <div className="space-y-4" data-testid="reports-admin-tab">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <h2 className="text-xl font-bold flex items-center gap-2"><Flag className="w-5 h-5 text-red-600" />Signalements ({list.length})</h2>
        <div className="flex gap-2">
          {[{ k: "pending", l: "En attente" }, { k: "resolved", l: "Résolus" }, { k: "all", l: "Tous" }].map((s) => (
            <Button key={s.k} variant={status === s.k ? "default" : "outline"} size="sm" className="rounded-full" onClick={() => setStatus(s.k)} data-testid={`reports-filter-${s.k}`}>{s.l}</Button>
          ))}
        </div>
      </div>
      {loading ? (
        <div className="card-soft p-8 text-center text-slate-500">Chargement…</div>
      ) : list.length === 0 ? (
        <div className="card-soft p-8 text-center text-slate-500" data-testid="reports-empty">Aucun signalement {status === "pending" ? "en attente" : ""}.</div>
      ) : (
        <>
        <div className="space-y-3">
          {list.slice(page * pageSize, (page + 1) * pageSize).map((r) => (
            <div key={r.report_id} className="card-soft p-4" data-testid={`report-row-${r.report_id}`}>
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div className="flex-1 min-w-[250px]">
                  <div className="flex items-center gap-2 mb-1">
                    <span className={`text-xs px-2 py-0.5 rounded-full ${r.target_type === "user" ? "bg-violet-100 text-violet-700" : "bg-amber-100 text-amber-700"}`}>{r.target_type === "user" ? "Utilisateur" : "Établissement"}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full ${r.status === "pending" ? "bg-red-100 text-red-700" : "bg-emerald-100 text-emerald-700"}`}>{r.status === "pending" ? "En attente" : "Résolu"}</span>
                    <span className="text-xs text-slate-500">{new Date(r.created_at).toLocaleString("fr-FR")}</span>
                  </div>
                  <div className="font-semibold text-slate-900">{r.target_label}</div>
                  <div className="text-sm text-slate-700 mt-1"><strong>Motif :</strong> {reasonLabel(r.reason)}</div>
                  {r.custom_text && <div className="text-sm text-slate-600 mt-1 italic">« {r.custom_text} »</div>}
                  <div className="text-xs text-slate-500 mt-2">Signalé par : {r.reporter_name} ({r.reporter_email})</div>
                </div>
                {r.status === "pending" && (
                  <div className="flex flex-col gap-2">
                    <a
                      href={targetUrl(r)}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center justify-center gap-1 text-xs px-3 py-1.5 rounded-full bg-sky-50 text-sky-700 hover:bg-sky-100 border border-sky-200"
                      data-testid={`view-${r.report_id}`}
                    >
                      <Eye className="w-3.5 h-3.5" />Voir la fiche
                    </a>
                    <Button size="sm" variant="outline" className="rounded-full" onClick={() => resolve(r.report_id)} data-testid={`resolve-${r.report_id}`}>
                      <CheckCircle2 className="w-3.5 h-3.5 mr-1" />Marquer résolu
                    </Button>
                  </div>
                )}
                {r.status !== "pending" && (
                  <div className="flex flex-col gap-2">
                    <a
                      href={targetUrl(r)}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center justify-center gap-1 text-xs px-3 py-1.5 rounded-full bg-sky-50 text-sky-700 hover:bg-sky-100 border border-sky-200"
                    >
                      <Eye className="w-3.5 h-3.5" />Voir la fiche
                    </a>
                    <Button size="sm" variant="outline" className="rounded-full border-amber-300 text-amber-700 hover:bg-amber-50" onClick={() => unresolve(r.report_id)} data-testid={`unresolve-${r.report_id}`}>
                      <CornerUpLeft className="w-3.5 h-3.5 mr-1" />Annuler l'action
                    </Button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <PaginationBar
          page={page} setPage={setPage}
          totalPages={Math.max(1, Math.ceil(list.length / pageSize))}
          pageSize={pageSize} setPageSize={(n) => { setPageSize(n); setPage(0); }}
          total={list.length} sizes={[20, 50, 100]} testId="adm-reports-pager"
        />
        </>
      )}
    </div>
  );
}

function BookingsTab() {
  const [list, setList] = useState([]);
  const [filters, setFilters] = useState({ status: "all", payment_status: "all" });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [historyUserId, setHistoryUserId] = useState(null);

  const reload = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.status !== "all") params.status = filters.status;
      if (filters.payment_status !== "all") params.payment_status = filters.payment_status;
      const { data } = await api.get("/admin/bookings", { params });
      setList(data);
      setPage(0);
    } finally { setLoading(false); }
  };
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, [filters]);

  const fmtDT = (iso) => iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—";
  const STATUS_LABEL = { pending: "En attente", confirmed: "Confirmée", completed: "Effectuée", cancelled: "Annulée", no_show: "No-show" };
  const PAY_LABEL = { pending: "En attente", paid: "Payé", cash_due: "Espèces dû", refunded: "Remboursé", failed: "Échec" };
  const STATUS_BG = { pending: "bg-amber-100 text-amber-700", confirmed: "bg-emerald-100 text-emerald-700", completed: "bg-sky-100 text-sky-700", cancelled: "bg-slate-200 text-slate-600", no_show: "bg-red-100 text-red-700" };

  return (
    <div data-testid="admin-bookings">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <div className="text-sm text-slate-600">{list.length} résultat(s)</div>
        <div className="ml-auto flex gap-2 items-center">
          <Label className="text-xs">Statut</Label>
          <select className="border rounded-lg px-2 py-1 text-sm" value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })} data-testid="adm-bk-status">
            {["all", "pending", "confirmed", "completed", "cancelled", "no_show"].map((s) => <option key={s} value={s}>{s === "all" ? "Tous" : STATUS_LABEL[s] || s}</option>)}
          </select>
          <Label className="text-xs">Paiement</Label>
          <select className="border rounded-lg px-2 py-1 text-sm" value={filters.payment_status} onChange={(e) => setFilters({ ...filters, payment_status: e.target.value })} data-testid="adm-bk-pay">
            {["all", "pending", "paid", "cash_due", "refunded", "failed"].map((s) => <option key={s} value={s}>{s === "all" ? "Tous" : PAY_LABEL[s] || s}</option>)}
          </select>
        </div>
      </div>
      {loading ? <div className="card-soft p-8 text-center text-slate-500">Chargement...</div> : (
        list.length === 0 ? <div className="card-soft p-8 text-center text-slate-500">Aucune réservation.</div> : (
          <>
          <div className="card-soft overflow-x-auto">
            <p className="text-[11px] text-slate-400 px-3 pt-2 md:hidden">← faites glisser pour voir toutes les colonnes →</p>
            <table className="w-full text-sm min-w-[820px]">
              <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500">
                <tr>
                  <th className="text-left p-3">Date</th>
                  <th className="text-left p-3">Client</th>
                  <th className="text-left p-3">MNS</th>
                  <th className="text-left p-3">Piscine</th>
                  <th className="text-left p-3">Mode</th>
                  <th className="text-right p-3">Montant</th>
                  <th className="text-left p-3">Statut</th>
                  <th className="text-left p-3">Paiement</th>
                </tr>
              </thead>
              <tbody>
                {list.slice(page * pageSize, (page + 1) * pageSize).map((b) => (
                  <tr key={b.booking_id} className="border-t hover:bg-slate-50" data-testid={`adm-bk-${b.booking_id}`}>
                    <td className="p-3 whitespace-nowrap">{fmtDT(b.start_dt)}</td>
                    <td className="p-3">
                      {b.client?.user_id ? (
                        <button
                          type="button"
                          onClick={() => setHistoryUserId(b.client.user_id)}
                          className="text-sky-700 hover:underline text-left"
                          data-testid={`adm-bk-client-${b.booking_id}`}
                        >
                          {b.client?.name}
                        </button>
                      ) : (b.client?.name || "—")}
                      <span className="text-xs text-slate-400 block">{b.client?.email}</span>
                    </td>
                    <td className="p-3">
                      {b.mns?.user_id ? (
                        <button
                          type="button"
                          onClick={() => setHistoryUserId(b.mns.user_id)}
                          className="text-sky-700 hover:underline text-left"
                          data-testid={`adm-bk-mns-${b.booking_id}`}
                        >
                          {b.mns?.name}
                        </button>
                      ) : (b.mns?.name || "—")}
                      <span className="text-xs text-slate-400 block">{b.mns?.email}</span>
                    </td>
                    <td className="p-3">{b.pool?.name || "—"}</td>
                    <td className="p-3">{b.payment_method === "online" ? "En ligne" : "Espèces"}</td>
                    <td className="p-3 text-right font-medium">{(b.amount || 0).toFixed(2)}€</td>
                    <td className="p-3"><span className={`text-xs px-2 py-0.5 rounded-full ${STATUS_BG[b.status] || "bg-slate-100"}`}>{STATUS_LABEL[b.status] || b.status}</span></td>
                    <td className="p-3 text-xs text-slate-600">{PAY_LABEL[b.payment_status] || b.payment_status || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <PaginationBar
            page={page} setPage={setPage}
            totalPages={Math.max(1, Math.ceil(list.length / pageSize))}
            pageSize={pageSize} setPageSize={(n) => { setPageSize(n); setPage(0); }}
            total={list.length} sizes={[20, 50, 100]} testId="adm-bk-pager"
          />
          </>
        )
      )}
      <UserHistoryDialog userId={historyUserId} open={!!historyUserId} onClose={() => setHistoryUserId(null)} />
    </div>
  );
}

function StatsTab() {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  const chartRefs = useRef({});

  useEffect(() => {
    api.get(`/admin/stats/advanced`, { params: { days } }).then((r) => setData(r.data)).catch(() => {});
  }, [days]);

  const copyChart = async (key) => {
    const node = chartRefs.current[key];
    if (!node) return;
    try {
      const png = await toPng(node, { cacheBust: true, pixelRatio: 2, backgroundColor: "#ffffff" });
      // Prefer clipboard image; fall back to download
      const blob = await (await fetch(png)).blob();
      if (window.ClipboardItem && navigator.clipboard?.write) {
        await navigator.clipboard.write([new window.ClipboardItem({ "image/png": blob })]);
        toast.success("Graphique copié dans le presse-papier");
      } else {
        const a = document.createElement("a");
        a.href = png; a.download = `${key}.png`; a.click();
        toast.success("Graphique téléchargé (copie non supportée par ce navigateur)");
      }
    } catch (e) {
      toast.error("Copie indisponible"); console.error(e);
    }
  };

  const exportCSV = () => {
    if (!data) return;
    const rows = [];
    rows.push(["Section", "Clé", "Valeur"]);
    Object.entries(data.totals).forEach(([k, v]) => rows.push(["totals", k, v]));
    data.bookings_per_day.forEach((r) => rows.push(["bookings_per_day", r.date, r.count]));
    data.revenue_per_day.forEach((r) => rows.push(["revenue_per_day", r.date, r.revenue]));
    data.signups_per_day.forEach((r) => rows.push(["signups_per_day", r.date, r.count]));
    data.bookings_by_status.forEach((r) => rows.push(["bookings_by_status", r.status, r.count]));
    data.top_mns.forEach((r) => rows.push(["top_mns", r.name, r.revenue]));
    data.top_pools.forEach((r) => rows.push(["top_pools", r.name, r.bookings]));
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
    downloadBlob(new Blob([csv], { type: "text/csv;charset=utf-8" }), `myswimminglessons_stats_${days}j.csv`);
    toast.success("Export CSV prêt");
  };

  const exportXLSX = () => {
    if (!data) return;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(Object.entries(data.totals).map(([k, v]) => ({ indicateur: k, valeur: v }))), "Totaux");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(data.bookings_per_day), "Réservations-jour");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(data.revenue_per_day), "CA-jour");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(data.signups_per_day), "Inscriptions-jour");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(data.bookings_by_status), "Par statut");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(data.top_mns), "Top MNS");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(data.top_pools), "Top piscines");
    XLSX.writeFile(wb, `myswimminglessons_stats_${days}j.xlsx`);
    toast.success("Export XLSX prêt");
  };

  const exportPDF = async () => {
    if (!data) return;
    const pdf = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();
    // Cover page with totals
    pdf.setFontSize(22); pdf.text("MySwimmingLessons — Statistiques plateforme", 15, 20);
    pdf.setFontSize(11); pdf.text(`Période : ${days} derniers jours — généré le ${new Date().toLocaleString("fr-FR")}`, 15, 28);
    pdf.setFontSize(12); pdf.text("Indicateurs clés", 15, 42);
    let y = 50;
    Object.entries(data.totals).forEach(([k, v]) => {
      pdf.setFontSize(10); pdf.text(`• ${k.padEnd(22, " ")} : ${v}`, 20, y); y += 6;
    });
    // One chart per page
    const keys = ["bookings_per_day", "revenue_per_day", "signups_per_day", "status_pie", "top_mns", "top_pools"];
    const titles = {
      bookings_per_day: "Réservations par jour",
      revenue_per_day: "Commissions plateforme par jour (€)",
      signups_per_day: "Inscriptions par jour",
      status_pie: "Répartition des réservations par statut",
      top_mns: "Top 5 MNS par commission plateforme",
      top_pools: "Top 5 piscines par réservations",
    };
    for (const k of keys) {
      const node = chartRefs.current[k];
      if (!node) continue;
      try {
        const png = await toPng(node, { cacheBust: true, pixelRatio: 2, backgroundColor: "#ffffff" });
        pdf.addPage();
        pdf.setFontSize(16); pdf.text(titles[k] || k, 15, 18);
        const maxW = pageW - 30, maxH = pageH - 35;
        pdf.addImage(png, "PNG", 15, 25, maxW, maxH);
      } catch (err) { console.warn("chart export skipped", k, err); }
    }
    pdf.save(`myswimminglessons_stats_${days}j.pdf`);
    toast.success("Export PDF prêt");
  };

  if (!data) return <div className="p-8 text-center text-slate-500">Chargement des statistiques…</div>;
  const { totals } = data;
  const PIE_COLORS = ["#0284c7", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#64748b"];

  return (
    <div className="space-y-5" data-testid="admin-stats">
      <MonthlyReportsPanel />
      <OnboardingRemindersPanel />

      {/* Toolbar */}
      <div className="flex flex-wrap items-center gap-3 card-soft p-3">
        <Label className="text-xs">Période</Label>
        <select className="border rounded-lg px-2 py-1 text-sm" value={days} onChange={(e) => setDays(parseInt(e.target.value, 10))} data-testid="stats-days">
          {[7, 14, 30, 60, 90].map((d) => <option key={d} value={d}>{d} jours</option>)}
        </select>
        <div className="ml-auto flex flex-wrap gap-2">
          <Button size="sm" variant="outline" className="rounded-full" onClick={exportCSV} data-testid="stats-export-csv"><Download className="w-3 h-3 mr-1" />CSV</Button>
          <Button size="sm" variant="outline" className="rounded-full" onClick={exportXLSX} data-testid="stats-export-xlsx"><FileSpreadsheet className="w-3 h-3 mr-1" />XLSX</Button>
          <Button size="sm" className="rounded-full bg-sky-700 hover:bg-sky-600" onClick={exportPDF} data-testid="stats-export-pdf"><FileText className="w-3 h-3 mr-1" />PDF</Button>
        </div>
      </div>

      {/* KPI cards */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {[
          ["Utilisateurs", totals.users], ["Clients", totals.clients],
          ["Maîtres-nageurs", totals.mns], ["Piscines", totals.pools],
          ["Réservations", totals.bookings], ["CA commissions", `${(totals.platform_revenue || 0).toFixed(2)}€`],
          ["Volume d'affaires", `${(totals.gmv || 0).toFixed(2)}€`], ["Admins", totals.admins],
        ].map(([l, v]) => (
          <div key={l} className="card-soft p-4">
            <div className="text-xs uppercase tracking-widest text-slate-500">{l}</div>
            <div className="text-2xl font-bold text-slate-900 mt-1" style={{ fontFamily: "Outfit" }}>{v}</div>
          </div>
        ))}
      </div>

      {/* Charts grid */}
      <div className="grid md:grid-cols-2 gap-4">
        <ChartCard title="Réservations par jour" testId="chart-bookings-per-day" refKey="bookings_per_day" chartRefs={chartRefs} onCopy={() => copyChart("bookings_per_day")}>
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={data.bookings_per_day}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={(d) => d.slice(5)} />
              <YAxis tick={{ fontSize: 10 }} allowDecimals={false} />
              <Tooltip />
              <Line type="monotone" dataKey="count" stroke="#0284c7" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </ChartCard>

        <ChartCard title="Commissions par jour (€)" testId="chart-revenue-per-day" refKey="revenue_per_day" chartRefs={chartRefs} onCopy={() => copyChart("revenue_per_day")}>
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={data.revenue_per_day}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={(d) => d.slice(5)} />
              <YAxis tick={{ fontSize: 10 }} />
              <Tooltip />
              <Line type="monotone" dataKey="revenue" stroke="#10b981" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </ChartCard>

        <ChartCard title="Inscriptions par jour" testId="chart-signups-per-day" refKey="signups_per_day" chartRefs={chartRefs} onCopy={() => copyChart("signups_per_day")}>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={data.signups_per_day}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={(d) => d.slice(5)} />
              <YAxis tick={{ fontSize: 10 }} allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="count" fill="#f59e0b" />
            </BarChart>
          </ResponsiveContainer>
        </ChartCard>

        <ChartCard title="Répartition par statut" testId="chart-status-pie" refKey="status_pie" chartRefs={chartRefs} onCopy={() => copyChart("status_pie")}>
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie data={data.bookings_by_status} dataKey="count" nameKey="status" outerRadius={80} label={{ fontSize: 10 }}>
                {data.bookings_by_status.map((entry, i) => <Cell key={entry.status || `slice-${i}`} fill={PIE_COLORS[i % PIE_COLORS.length]} />)}
              </Pie>
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: 11 }} />
            </PieChart>
          </ResponsiveContainer>
        </ChartCard>

        <ChartCard title="Top 5 MNS par commission" testId="chart-top-mns" refKey="top_mns" chartRefs={chartRefs} onCopy={() => copyChart("top_mns")}>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={data.top_mns} layout="vertical" margin={{ left: 20 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" tick={{ fontSize: 10 }} />
              <YAxis dataKey="name" type="category" tick={{ fontSize: 10 }} width={100} />
              <Tooltip />
              <Bar dataKey="revenue" fill="#0284c7" />
            </BarChart>
          </ResponsiveContainer>
        </ChartCard>

        <ChartCard title="Top 5 piscines (réservations)" testId="chart-top-pools" refKey="top_pools" chartRefs={chartRefs} onCopy={() => copyChart("top_pools")}>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={data.top_pools} layout="vertical" margin={{ left: 20 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" tick={{ fontSize: 10 }} allowDecimals={false} />
              <YAxis dataKey="name" type="category" tick={{ fontSize: 10 }} width={100} />
              <Tooltip />
              <Bar dataKey="bookings" fill="#8b5cf6" />
            </BarChart>
          </ResponsiveContainer>
        </ChartCard>
      </div>
    </div>
  );
}

function ChartCard({ title, testId, refKey, chartRefs, onCopy, children }) {
  return (
    <div className="card-soft p-4" data-testid={testId}>
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-semibold text-slate-900">{title}</h3>
        <Button size="sm" variant="outline" className="rounded-full" onClick={onCopy} data-testid={`${testId}-copy`}>
          <Copy className="w-3 h-3 mr-1" />Copier
        </Button>
      </div>
      <div ref={(el) => { if (el) chartRefs.current[refKey] = el; }} className="bg-white rounded-xl">
        {children}
      </div>
    </div>
  );
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 500);
}

function OnboardingRemindersPanel() {
  const [stats, setStats] = React.useState(null);
  const [busy, setBusy] = React.useState(false);
  // Iter53 — drill-down modal state
  const [openStage, setOpenStage] = React.useState(null); // "day2" | "day7" | ...
  const [details, setDetails] = React.useState(null); // {stage, items, count}
  const [detailsLoading, setDetailsLoading] = React.useState(false);
  const [rowBusy, setRowBusy] = React.useState(null); // user_id currently acting

  const load = React.useCallback(async () => {
    try {
      const { data } = await api.get("/admin/mns/onboarding-stats");
      setStats(data);
    } catch (e) { /* silent */ }
  }, []);
  React.useEffect(() => { load(); }, [load]);

  const runNow = async () => {
    setBusy(true);
    try {
      await api.post("/admin/mns/send-onboarding-reminders");
      toast.success("Relances envoyées");
      await load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally { setBusy(false); }
  };

  const openDrilldown = async (stage) => {
    setOpenStage(stage);
    setDetails(null);
    setDetailsLoading(true);
    try {
      const { data } = await api.get(`/admin/mns/onboarding-stats/details?stage=${stage}`);
      setDetails(data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Impossible de charger le détail");
    } finally { setDetailsLoading(false); }
  };

  const reloadDetails = async () => {
    if (!openStage) return;
    try {
      const { data } = await api.get(`/admin/mns/onboarding-stats/details?stage=${openStage}`);
      setDetails(data);
    } catch { /* ignore */ }
    load();
  };

  const relanceOne = async (uid) => {
    setRowBusy(uid);
    try {
      await api.post(`/admin/mns/${uid}/send-onboarding-reminder?stage=${openStage}`);
      toast.success("Relance envoyée");
      await reloadDetails();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally { setRowBusy(null); }
  };

  const skipOne = async (uid, email) => {
    if (!window.confirm(`Retirer ${email || uid} des relances onboarding (le compte reste actif) ?`)) return;
    setRowBusy(uid);
    try {
      await api.post(`/admin/mns/${uid}/skip-onboarding-reminders`);
      toast.success("Retiré des relances");
      await reloadDetails();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally { setRowBusy(null); }
  };

  const deleteOne = async (uid, email) => {
    if (!window.confirm(`⚠️ SUPPRIMER DÉFINITIVEMENT le compte MNS « ${email || uid} » ?\n\nCette action est irréversible.`)) return;
    setRowBusy(uid);
    try {
      await api.delete(`/admin/users/${uid}`);
      toast.success("Compte supprimé");
      await reloadDetails();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally { setRowBusy(null); }
  };

  if (!stats) return null;
  const stagesMeta = {
    day2: { label: "J+2 (encourageant)", color: "bg-sky-100 text-sky-800" },
    day7: { label: "J+7 (rappel)", color: "bg-amber-100 text-amber-800" },
    day14: { label: "J+14 (alerte)", color: "bg-orange-100 text-orange-800" },
    day30: { label: "J+30+ (masqué)", color: "bg-red-100 text-red-800" },
  };
  return (
    <div className="card-soft p-4" data-testid="onboarding-reminders-panel">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <div>
          <h3 className="font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>Relances onboarding MNS</h3>
          <p className="text-xs text-slate-500">MNS incomplets par fenêtre (diplôme ou attestation manquants). Cliquez sur une case pour le détail.</p>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs px-2 py-1 rounded-full bg-slate-100 text-slate-700" data-testid="onboarding-total">
            Total incomplets : {stats.total_incomplete}
          </span>
          <Button size="sm" variant="outline" className="rounded-full" onClick={runNow} disabled={busy} data-testid="onboarding-run-now">
            {busy ? "..." : "Lancer les relances maintenant"}
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {Object.entries(stagesMeta).map(([k, meta]) => {
          const s = stats.stages[k] || {};
          const inc = s.still_incomplete || 0;
          const clickable = inc > 0;
          return (
            <button
              key={k} type="button"
              onClick={() => clickable && openDrilldown(k)}
              disabled={!clickable}
              className={`text-left border rounded-xl p-3 transition ${clickable ? "hover:border-sky-400 hover:shadow cursor-pointer" : "opacity-70 cursor-not-allowed"}`}
              data-testid={`onboarding-stage-${k}`}
            >
              <div className={`text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-full inline-block ${meta.color}`}>{meta.label}</div>
              <div className="text-2xl font-bold text-slate-900 mt-1" style={{ fontFamily: "Outfit" }}>{inc}</div>
              <div className="text-[11px] text-slate-500">/{s.total_in_window || 0} MNS dans la fenêtre</div>
              {clickable && <div className="text-[10px] text-sky-700 mt-1">Cliquer pour voir la liste →</div>}
            </button>
          );
        })}
      </div>

      {/* Iter53 — drill-down modal */}
      <Dialog open={!!openStage} onOpenChange={(o) => !o && setOpenStage(null)}>
        <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto" data-testid="onboarding-drilldown-dialog">
          <DialogHeader>
            <DialogTitle>MNS incomplets — {openStage && stagesMeta[openStage]?.label}</DialogTitle>
            <DialogDescription>
              {detailsLoading ? "Chargement..." : `${details?.count ?? 0} MNS dans cette fenêtre n'ont pas finalisé leur inscription.`}
            </DialogDescription>
          </DialogHeader>
          {!detailsLoading && details && details.items.length === 0 && (
            <div className="p-6 text-center text-slate-500">Aucun MNS incomplet dans cette fenêtre 🎉</div>
          )}
          {!detailsLoading && details && details.items.length > 0 && (
            <div className="space-y-2">
              {details.items.map((it) => (
                <div key={it.user_id} className="border rounded-xl p-3 flex flex-col sm:flex-row sm:items-center gap-3 justify-between" data-testid={`onboarding-row-${it.user_id}`}>
                  <div className="min-w-0 flex-1">
                    <div className="font-semibold text-slate-900 truncate">{it.name || "—"}</div>
                    <div className="text-xs text-slate-600 truncate">{it.email}</div>
                    <div className="text-[11px] text-slate-500 mt-0.5">
                      Inscrit le {(it.created_at || "").slice(0, 10) || "—"}
                      {it.onboarding_base_date && it.onboarding_base_date !== it.created_at && (
                        <> · Base J+ : {it.onboarding_base_date.slice(0, 10)}</>
                      )}
                    </div>
                    <div className="mt-1 flex flex-wrap gap-1">
                      {(it.missing || []).includes("diplome") && (
                        <span className="text-[10px] px-2 py-0.5 rounded-full bg-red-100 text-red-700 font-medium">📜 Diplôme manquant</span>
                      )}
                      {(it.missing || []).includes("insurance") && (
                        <span className="text-[10px] px-2 py-0.5 rounded-full bg-red-100 text-red-700 font-medium">🛡️ Attestation manquante</span>
                      )}
                      {(it.reminders_sent || []).length > 0 && (
                        <span className="text-[10px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-600" title={JSON.stringify(it.reminders_dates || {})}>
                          Emails déjà envoyés : {(it.reminders_sent || []).join(", ")}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-1.5 shrink-0">
                    <Button size="sm" variant="outline" className="rounded-full h-8 text-xs"
                            disabled={rowBusy === it.user_id}
                            onClick={() => relanceOne(it.user_id)}
                            data-testid={`onboarding-row-relance-${it.user_id}`}>
                      <Mail className="w-3 h-3 mr-1" />Relancer
                    </Button>
                    <Button size="sm" variant="outline" className="rounded-full h-8 text-xs border-amber-400 text-amber-800 hover:bg-amber-50"
                            disabled={rowBusy === it.user_id}
                            onClick={() => skipOne(it.user_id, it.email)}
                            data-testid={`onboarding-row-skip-${it.user_id}`}>
                      Retirer des relances
                    </Button>
                    <Button size="sm" variant="outline" className="rounded-full h-8 text-xs border-red-400 text-red-700 hover:bg-red-50"
                            disabled={rowBusy === it.user_id}
                            onClick={() => deleteOne(it.user_id, it.email)}
                            data-testid={`onboarding-row-delete-${it.user_id}`}>
                      <Trash2 className="w-3 h-3 mr-1" />Supprimer le compte
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

function MonthlyReportsPanel() {
  const [list, setList] = useState([]);
  const [busy, setBusy] = useState(false);
  const reload = () => api.get("/admin/monthly-reports").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { reload(); }, []);
  const generate = async () => {
    setBusy(true);
    try {
      await api.post("/admin/monthly-reports/generate");
      toast.success("Rapport mensuel généré");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    finally { setBusy(false); }
  };
  const download = async (period) => {
    try {
      const res = await api.get(`/admin/monthly-reports/${period}/pdf`, { responseType: "blob" });
      downloadBlob(res.data, `myswimminglessons_${period}.pdf`);
    } catch { toast.error("Téléchargement impossible"); }
  };
  return (
    <div className="card-soft p-4" data-testid="monthly-reports">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-2">
        <div>
          <h3 className="font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>Rapports mensuels</h3>
          <p className="text-xs text-slate-500">Générés automatiquement le 1er de chaque mois à 9h (Europe/Paris) et envoyés par email aux admins.</p>
        </div>
        <Button size="sm" variant="outline" className="rounded-full" onClick={generate} disabled={busy} data-testid="generate-monthly">
          <FileText className="w-3 h-3 mr-1" />{busy ? "Génération…" : "Générer maintenant"}
        </Button>
      </div>
      {list.length === 0 ? (
        <p className="text-sm text-slate-500">Aucun rapport encore généré. Cliquez « Générer maintenant » pour créer celui du mois précédent.</p>
      ) : (
        <div className="flex gap-2 overflow-x-auto pt-2">
          {list.map((r) => (
            <button key={r.report_id} onClick={() => download(r.period)}
              className="border rounded-xl px-3 py-2 text-left hover:bg-sky-50 transition shrink-0"
              data-testid={`monthly-${r.period}`}>
              <div className="text-sm font-semibold text-slate-900">{r.period}</div>
              <div className="text-xs text-slate-500">{Math.round((r.size || 0) / 1024)} Ko • <span className="text-sky-700">Télécharger</span></div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function DocsTab() {
  const [tab, setTab] = useState("diplomas");
  return (
    <div data-testid="admin-docs">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-slate-100 p-1 rounded-xl mb-4">
          <TabsTrigger value="diplomas" data-testid="docs-tab-diplomas">Diplômes</TabsTrigger>
          <TabsTrigger value="insurance" data-testid="docs-tab-insurance">Assurances</TabsTrigger>
        </TabsList>
        <TabsContent value="diplomas"><DocsList kind="diplomas" /></TabsContent>
        <TabsContent value="insurance"><DocsList kind="insurance" /></TabsContent>
      </Tabs>
    </div>
  );
}

function DocsList({ kind }) {
  const [pending, setPending] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [rejectFor, setRejectFor] = useState(null);
  const [reason, setReason] = useState("");
  const baseUrl = kind === "diplomas" ? "diplomas" : "insurance";
  const idKey = kind === "diplomas" ? "diploma_id" : "insurance_id";

  const reload = () => api.get(`/admin/${baseUrl}/pending`).then((r) => setPending(r.data)).catch(() => {});
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, [kind]);

  const validate = async (d) => {
    try {
      await api.post(`/admin/${baseUrl}/${d[idKey]}/validate`);
      toast.success("Document validé");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };
  const reject = async () => {
    if (!rejectFor) return;
    try {
      await api.post(`/admin/${baseUrl}/${rejectFor[idKey]}/reject`, { reason });
      toast.success("Document rejeté");
      setRejectFor(null); setReason("");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };
  const preview = async (d) => {
    try {
      const { data } = await api.get(`/${baseUrl === "diplomas" ? "diplomas" : "insurance"}/${d[idKey]}/url`);
      const url = data.url.startsWith("http") ? data.url : `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
      setPreviewUrl(url);
    } catch { toast.error("Aperçu indisponible"); }
  };

  return (
    <div data-testid={`admin-${kind}`}>
      <p className="text-sm text-slate-600 mb-3">{pending.length} document(s) en attente.</p>
      {pending.length === 0 && <div className="card-soft p-8 text-center text-slate-500">Aucun document à valider.</div>}
      <div className="space-y-3">
        {pending.map((d) => (
          <div key={d[idKey]} className="card-soft p-4 flex flex-wrap items-center justify-between gap-3" data-testid={`pending-${kind}-${d[idKey]}`}>
            <div>
              <div className="font-semibold text-slate-900">{kind === "diplomas" ? (d.name || "Document") : "Attestation d'assurance"}</div>
              <div className="text-xs text-slate-500">
                {kind === "diplomas" && d.doc_type && <span className="inline-block bg-slate-100 text-slate-700 px-2 py-0.5 rounded-full mr-1">{d.doc_type}</span>}
                MNS : {d.owner?.name} ({d.owner?.email}) • {d.original_filename} • valide jusqu'au {d.valid_until}
              </div>
              <div className="text-xs text-amber-700 mt-1">En attente</div>
            </div>
            <div className="flex gap-2">
              <Button size="sm" variant="outline" className="rounded-full" onClick={() => preview(d)} data-testid={`preview-${kind}-${d[idKey]}`}>
                <Eye className="w-3 h-3 mr-1" />Aperçu
              </Button>
              <Button size="sm" className="rounded-full bg-emerald-600 hover:bg-emerald-700" onClick={() => validate(d)} data-testid={`validate-${kind}-${d[idKey]}`}>
                <CheckCircle2 className="w-3 h-3 mr-1" />Valider
              </Button>
              <Button size="sm" variant="outline" className="rounded-full text-red-600 border-red-300" onClick={() => { setRejectFor(d); setReason(""); }} data-testid={`reject-${kind}-${d[idKey]}`}>
                <XCircle className="w-3 h-3 mr-1" />Rejeter
              </Button>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={!!previewUrl} onOpenChange={(v) => !v && setPreviewUrl(null)}>
        <DialogContent className="max-w-3xl">
          <DialogHeader><DialogTitle>Aperçu du document</DialogTitle></DialogHeader>
          {previewUrl && (
            previewUrl.match(/\.pdf/i)
              ? <iframe src={previewUrl} className="w-full h-[70vh] rounded" title="doc" />
              : <img src={previewUrl} alt="doc" className="w-full max-h-[70vh] object-contain" />
          )}
        </DialogContent>
      </Dialog>

      <Dialog open={!!rejectFor} onOpenChange={(v) => !v && setRejectFor(null)}>
        <DialogContent>
          <DialogHeader><DialogTitle>Motif du rejet</DialogTitle></DialogHeader>
          <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Expliquez la raison du rejet (visible par le MNS)" data-testid="reject-reason" />
          <DialogFooter>
            <Button variant="outline" className="rounded-full" onClick={() => setRejectFor(null)}>Annuler</Button>
            <Button className="rounded-full bg-red-600 hover:bg-red-700" onClick={reject} data-testid="reject-confirm-btn">Confirmer le rejet</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

function UsersTab() {
  const [list, setList] = useState([]);
  const [filters, setFilters] = useState({ role: "all", suspended: "all", q: "", includeTest: false });
  const [delTarget, setDelTarget] = useState(null);
  const [editTarget, setEditTarget] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [historyUserId, setHistoryUserId] = useState(null);

  const reload = async () => {
    const params = {};
    if (filters.role !== "all") params.role = filters.role;
    if (filters.suspended !== "all") params.suspended = filters.suspended === "yes";
    if (filters.q) params.q = filters.q;
    // Iter54 — allow admin to opt-in to see test/demo accounts
    if (filters.includeTest) params.include_test = true;
    const { data } = await api.get("/admin/users", { params });
    setList(data);
    setPage(0);
  };
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, [filters.role, filters.suspended, filters.includeTest]);

  // Debounced refetch on search input: when the user clears the field, restore the full list.
  useEffect(() => {
    const h = setTimeout(() => { reload(); }, 350);
    return () => clearTimeout(h);
    // eslint-disable-next-line
  }, [filters.q]);

  const search = (e) => { e.preventDefault(); reload(); };

  const toggleSuspend = async (u) => {
    const next = !u.suspended;
    let reason = "";
    if (next) {
      reason = window.prompt("Motif du blocage (visible par le MNS) :", "") || "";
      if (reason === null) return;
    }
    try {
      await api.post(`/admin/users/${u.user_id}/suspend`, { suspended: next, reason });
      toast.success(next ? "Utilisateur bloqué" : "Utilisateur réactivé");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  const openEdit = (u) => {
    setEditTarget(u);
    setEditForm({
      email: u.email || "", phone: u.phone || "", name: u.name || "",
      first_name: u.first_name || "", last_name: u.last_name || "",
      civility: u.civility || "", birth_date: u.birth_date || "",
    });
  };

  const saveEdit = async () => {
    if (!editTarget) return;
    try {
      await api.put(`/admin/users/${editTarget.user_id}`, editForm);
      toast.success("Utilisateur mis à jour");
      setEditTarget(null);
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  const doDelete = async () => {
    if (!delTarget) return;
    try {
      await api.delete(`/admin/users/${delTarget.user_id}`);
      toast.success("Utilisateur supprimé");
      setDelTarget(null);
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  return (
    <div data-testid="admin-users">
      <form onSubmit={search} className="flex flex-wrap gap-3 items-center mb-4">
        <Input placeholder="Recherche nom ou email…" value={filters.q} onChange={(e) => setFilters({ ...filters, q: e.target.value })} className="max-w-xs" data-testid="adm-users-search" />
        <select className="border rounded-lg px-2 py-1 text-sm" value={filters.role} onChange={(e) => setFilters({ ...filters, role: e.target.value })} data-testid="adm-users-role">
          <option value="all">Tous les rôles</option>
          <option value="client">Clients</option>
          <option value="mns">MNS</option>
          <option value="admin">Admin</option>
        </select>
        <select className="border rounded-lg px-2 py-1 text-sm" value={filters.suspended} onChange={(e) => setFilters({ ...filters, suspended: e.target.value })} data-testid="adm-users-status">
          <option value="all">Tous statuts</option>
          <option value="no">Actifs</option>
          <option value="yes">Bloqués</option>
        </select>
        <label className="flex items-center gap-1.5 text-xs text-slate-600 border rounded-lg px-2 py-1 cursor-pointer" data-testid="adm-users-include-test-label">
          <input type="checkbox" checked={filters.includeTest} onChange={(e) => setFilters({ ...filters, includeTest: e.target.checked })} data-testid="adm-users-include-test" />
          Afficher les comptes tests
        </label>
        <Button size="sm" variant="outline" className="rounded-full">Rechercher</Button>
        <span className="text-sm text-slate-500 ml-auto">{list.length} résultat(s)</span>
      </form>
      <div className="card-soft overflow-x-auto">
        {/* Scroll hint on mobile/narrow viewports */}
        <p className="text-[11px] text-slate-400 px-3 pt-2 md:hidden">← faites glisser pour voir toutes les colonnes →</p>
        <table className="w-full text-sm min-w-[820px]">
          <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500">
            <tr>
              <th className="text-left p-3">Nom</th>
              <th className="text-left p-3">Email</th>
              <th className="text-left p-3">Téléphone</th>
              <th className="text-left p-3">Rôle</th>
              <th className="text-left p-3">Statut</th>
              <th className="text-left p-3">Inscrit le</th>
              <th className="text-right p-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {list.slice(page * pageSize, (page + 1) * pageSize).map((u) => (
              <tr key={u.user_id} className="border-t hover:bg-slate-50" data-testid={`adm-user-${u.user_id}`}>
                <td className="p-3 font-medium">
                  <button
                    type="button"
                    onClick={() => setHistoryUserId(u.user_id)}
                    className="text-sky-700 hover:underline"
                    data-testid={`history-${u.user_id}`}
                  >
                    {u.name}
                  </button>
                </td>
                <td className="p-3 text-slate-600">{u.email}</td>
                <td className="p-3 text-slate-600">{u.phone || "—"}</td>
                <td className="p-3"><span className="text-xs uppercase tracking-wide bg-sky-100 text-sky-700 px-2 py-0.5 rounded-full">{u.role}</span></td>
                <td className="p-3">{u.suspended
                  ? <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded-full" title={u.suspended_reason || ""}>Bloqué</span>
                  : <span className="text-xs bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded-full">Actif</span>}</td>
                <td className="p-3 text-xs text-slate-500">{u.created_at ? new Date(u.created_at).toLocaleDateString("fr-FR") : "—"}</td>
                <td className="p-3 text-right">
                  {u.role !== "admin" && (
                    <div className="inline-flex gap-2 flex-wrap">
                      <Button size="sm" variant="outline" className="rounded-full" onClick={() => setHistoryUserId(u.user_id)} data-testid={`details-${u.user_id}`}>
                        <Eye className="w-3 h-3 mr-1" />Détails
                      </Button>
                      <Button size="sm" variant="outline" className="rounded-full" onClick={() => openEdit(u)} data-testid={`edit-${u.user_id}`}>
                        <Edit3 className="w-3 h-3 mr-1" />Modifier
                      </Button>
                      <Button size="sm" variant="outline" className="rounded-full" onClick={() => toggleSuspend(u)} data-testid={`suspend-${u.user_id}`}>
                        <ShieldOff className="w-3 h-3 mr-1" />{u.suspended ? "Réactiver" : "Bloquer"}
                      </Button>
                      <Button size="sm" variant="outline" className="rounded-full text-red-600 border-red-300" onClick={() => setDelTarget(u)} data-testid={`delete-${u.user_id}`}>
                        <Trash2 className="w-3 h-3 mr-1" />Supprimer
                      </Button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <PaginationBar
        page={page} setPage={setPage}
        totalPages={Math.max(1, Math.ceil(list.length / pageSize))}
        pageSize={pageSize} setPageSize={(n) => { setPageSize(n); setPage(0); }}
        total={list.length} sizes={[20, 50, 100]} testId="adm-users-pager"
      />

      <Dialog open={!!editTarget} onOpenChange={(v) => !v && setEditTarget(null)}>
        <DialogContent>
          <DialogHeader><DialogTitle>Modifier l'utilisateur</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div className="grid sm:grid-cols-2 gap-3">
              <div>
                <Label>Civilité</Label>
                <select className="w-full border rounded-xl h-9 px-3 text-sm" value={editForm.civility || ""} onChange={(e) => setEditForm({ ...editForm, civility: e.target.value })} data-testid="edit-civility">
                  <option value="">—</option>
                  <option value="M">Monsieur</option>
                  <option value="Mme">Madame</option>
                  <option value="Autre">Autre</option>
                </select>
              </div>
              <div><Label>Date de naissance</Label><Input type="date" value={editForm.birth_date || ""} onChange={(e) => setEditForm({ ...editForm, birth_date: e.target.value })} data-testid="edit-birthdate" /></div>
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              <div><Label>Prénom</Label><Input value={editForm.first_name || ""} onChange={(e) => setEditForm({ ...editForm, first_name: e.target.value })} data-testid="edit-firstname" /></div>
              <div><Label>Nom</Label><Input value={editForm.last_name || ""} onChange={(e) => setEditForm({ ...editForm, last_name: e.target.value })} data-testid="edit-lastname" /></div>
            </div>
            <div><Label>Nom affiché</Label><Input value={editForm.name || ""} onChange={(e) => setEditForm({ ...editForm, name: e.target.value })} data-testid="edit-name" /></div>
            <div><Label>Email</Label><Input type="email" value={editForm.email || ""} onChange={(e) => setEditForm({ ...editForm, email: e.target.value })} data-testid="edit-email" /></div>
            <div><Label>Téléphone</Label><Input value={editForm.phone || ""} onChange={(e) => setEditForm({ ...editForm, phone: e.target.value })} data-testid="edit-phone" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" className="rounded-full" onClick={() => setEditTarget(null)}>Annuler</Button>
            <Button className="rounded-full bg-sky-700 hover:bg-sky-600" onClick={saveEdit} data-testid="edit-save">Enregistrer</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={!!delTarget} onOpenChange={(v) => !v && setDelTarget(null)}>
        <DialogContent>
          <DialogHeader><DialogTitle>Supprimer définitivement cet utilisateur ?</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">
            <strong>{delTarget?.name}</strong> ({delTarget?.email}) sera supprimé définitivement.
            Toutes ses réservations actives seront annulées et ses créneaux retirés. Cette action est <strong>irréversible</strong>.
          </p>
          <DialogFooter>
            <Button variant="outline" className="rounded-full" onClick={() => setDelTarget(null)}>Annuler</Button>
            <Button className="rounded-full bg-red-600 hover:bg-red-700" onClick={doDelete} data-testid="delete-confirm">Supprimer définitivement</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <UserHistoryDialog userId={historyUserId} open={!!historyUserId} onClose={() => setHistoryUserId(null)} />
    </div>
  );
}

function SlotsTab() {
  const [list, setList] = useState([]);
  const [onlyBooked, setOnlyBooked] = useState(false);
  const [loading, setLoading] = useState(true);

  const reload = async () => {
    setLoading(true);
    try {
      const params = {};
      if (onlyBooked) params.only_with_bookings = true;
      const { data } = await api.get("/admin/availabilities", { params });
      setList(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, [onlyBooked]);

  const fmtDT = (iso) => iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—";

  return (
    <div data-testid="admin-slots">
      <div className="flex items-center gap-3 mb-4">
        <label className="text-sm flex items-center gap-2 cursor-pointer">
          <input type="checkbox" checked={onlyBooked} onChange={(e) => setOnlyBooked(e.target.checked)} data-testid="adm-slots-only-booked" />
          Uniquement les créneaux avec au moins une réservation
        </label>
        <span className="ml-auto text-sm text-slate-500">{list.length} créneau(x)</span>
      </div>
      {loading ? <div className="card-soft p-8 text-center text-slate-500">Chargement...</div> : (
        list.length === 0 ? <div className="card-soft p-8 text-center text-slate-500">Aucun créneau.</div> : (
          <div className="card-soft overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500">
                <tr>
                  <th className="text-left p-3">Date / heure</th>
                  <th className="text-left p-3">MNS</th>
                  <th className="text-left p-3">Piscine</th>
                  <th className="text-right p-3">Tarif</th>
                  <th className="text-center p-3">Places</th>
                  <th className="text-left p-3">Niveaux mixtes</th>
                </tr>
              </thead>
              <tbody>
                {list.map((a) => (
                  <tr key={a.avail_id} className="border-t hover:bg-slate-50" data-testid={`adm-slot-${a.avail_id}`}>
                    <td className="p-3 whitespace-nowrap">{fmtDT(a.start_dt)}</td>
                    <td className="p-3">{a.mns?.name || "—"} <span className="text-xs text-slate-400 block">{a.mns?.email}</span></td>
                    <td className="p-3">{a.pool?.name || "—"}</td>
                    <td className="p-3 text-right font-medium">{a.price ? `${a.price}€` : <span className="text-slate-400">défaut</span>}</td>
                    <td className="p-3 text-center"><span className={`text-xs px-2 py-0.5 rounded-full ${a.booked_count >= a.max_students ? "bg-emerald-100 text-emerald-700" : a.booked_count > 0 ? "bg-amber-100 text-amber-700" : "bg-slate-200 text-slate-600"}`}>{a.booked_count}/{a.max_students}</span></td>
                    <td className="p-3 text-xs">{a.accepts_mixed_levels ? <span className="text-emerald-700">Oui</span> : <span className="text-slate-500">Non</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}

function AppReviewsAdminTab() {
  const [data, setData] = useState({ reviews: [], avg: null, count: 0 });
  const [replyFor, setReplyFor] = useState(null);
  const [reply, setReply] = useState("");

  const reload = async () => {
    const r = await api.get("/app-reviews"); setData(r.data);
  };
  useEffect(() => { reload(); }, []);

  const submitReply = async () => {
    try {
      await api.post(`/admin/app-reviews/${replyFor.review_id}/reply`, { reply });
      toast.success("Réponse publiée");
      setReplyFor(null); setReply("");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  const del = async (r) => {
    if (!window.confirm("Supprimer cet avis ?")) return;
    try {
      await api.delete(`/admin/app-reviews/${r.review_id}`);
      toast.success("Avis supprimé");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  return (
    <div data-testid="admin-app-reviews">
      <div className="flex items-baseline gap-3 mb-4">
        <h2 className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>Avis sur la plateforme</h2>
        {data.avg !== null && <span className="text-sm text-slate-600">Note moyenne : <strong>{data.avg}/5</strong> ({data.count} avis)</span>}
      </div>
      {data.reviews.length === 0 && <div className="card-soft p-8 text-center text-slate-500">Aucun avis pour le moment.</div>}
      <div className="space-y-3">
        {data.reviews.map((r) => (
          <div key={r.review_id} className="card-soft p-4" data-testid={`adm-review-${r.review_id}`}>
            <div className="flex items-center justify-between flex-wrap gap-2">
              <div className="flex items-center gap-2">
                <div className="inline-flex">
                  {[1,2,3,4,5].map((i) => <Star key={i} className={`w-4 h-4 ${i <= r.rating ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />)}
                </div>
                <span className="font-semibold">{r.user_name}</span>
                <span className="text-xs uppercase bg-sky-100 text-sky-700 px-2 py-0.5 rounded-full">{r.user_role}</span>
                <span className="text-xs text-slate-400">{new Date(r.created_at).toLocaleDateString("fr-FR")}</span>
              </div>
              <div className="flex gap-2">
                <Button size="sm" variant="outline" className="rounded-full" onClick={() => { setReplyFor(r); setReply(r.admin_reply || ""); }} data-testid={`reply-${r.review_id}`}>
                  <Reply className="w-3 h-3 mr-1" />{r.admin_reply ? "Modifier la réponse" : "Répondre"}
                </Button>
                <Button size="sm" variant="outline" className="rounded-full text-red-600 border-red-300" onClick={() => del(r)} data-testid={`del-review-${r.review_id}`}>
                  <Trash2 className="w-3 h-3 mr-1" />Supprimer
                </Button>
              </div>
            </div>
            {r.comment && <p className="text-sm text-slate-700 mt-2 whitespace-pre-line">{r.comment}</p>}
            {r.admin_reply && (
              <div className="mt-2 border-l-4 border-sky-300 bg-sky-50/50 p-3 rounded-r-xl">
                <div className="text-xs text-sky-800 font-semibold mb-1">Votre réponse :</div>
                <p className="text-sm text-slate-700 whitespace-pre-line">{r.admin_reply}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      <Dialog open={!!replyFor} onOpenChange={(v) => !v && setReplyFor(null)}>
        <DialogContent>
          <DialogHeader><DialogTitle>Répondre à l'avis</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-500">Votre réponse sera visible publiquement sous l'avis.</p>
          <Textarea value={reply} onChange={(e) => setReply(e.target.value)} rows={5} placeholder="Merci pour votre retour…" data-testid="review-reply-text" />
          <DialogFooter>
            <Button variant="outline" className="rounded-full" onClick={() => setReplyFor(null)}>Annuler</Button>
            <Button className="rounded-full bg-sky-700 hover:bg-sky-600" onClick={submitReply} data-testid="review-reply-submit">Publier la réponse</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

function ContactAdminTab() {
  const [list, setList] = useState([]);
  const [status, setStatus] = useState("all");
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);

  const reload = async () => {
    const params = {};
    if (status !== "all") params.status = status;
    const { data } = await api.get("/admin/contact", { params });
    setList(data);
  };
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, [status]);

  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return list;
    return list.filter((m) =>
      (m.name || "").toLowerCase().includes(needle) ||
      (m.email || "").toLowerCase().includes(needle) ||
      (m.subject || "").toLowerCase().includes(needle) ||
      (m.body || "").toLowerCase().includes(needle)
    );
  }, [list, q]);

  const setSt = async (cid, newSt) => {
    try {
      await api.post(`/admin/contact/${cid}/status`, null, { params: { status: newSt } });
      toast.success("Statut mis à jour");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  const STATUS_BG = { new: "bg-amber-100 text-amber-700", read: "bg-slate-200 text-slate-700", replied: "bg-emerald-100 text-emerald-700" };
  const STATUS_LABEL = { new: "Nouveau", read: "Lu", replied: "Répondu" };

  return (
    <div data-testid="admin-contact">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <div className="relative flex-1 max-w-sm">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input placeholder="Rechercher nom, email, sujet, message…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-10" data-testid="adm-contact-search" />
        </div>
        <Label className="text-xs">Statut</Label>
        <select className="border rounded-lg px-2 py-1 text-sm" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="adm-contact-status">
          {["all", "new", "read", "replied"].map((s) => <option key={s} value={s}>{s === "all" ? "Tous" : STATUS_LABEL[s]}</option>)}
        </select>
        <span className="ml-auto text-sm text-slate-500">{filtered.length} / {list.length} message(s)</span>
      </div>
      {filtered.length === 0 && <div className="card-soft p-8 text-center text-slate-500">Aucun message.</div>}
      <div className="space-y-2">
        {filtered.map((m) => (
          <div key={m.contact_id} className="card-soft p-4" data-testid={`adm-contact-${m.contact_id}`}>
            <div className="flex items-center justify-between gap-3 flex-wrap">
              <div>
                <div className="font-semibold text-slate-900">{m.subject}</div>
                <div className="text-xs text-slate-500">{m.name} — <a href={`mailto:${m.email}`} className="text-sky-700 hover:underline">{m.email}</a> • {new Date(m.created_at).toLocaleString("fr-FR")}</div>
              </div>
              <div className="flex items-center gap-2">
                <span className={`text-xs px-2 py-0.5 rounded-full ${STATUS_BG[m.status]}`}>{STATUS_LABEL[m.status]}</span>
                <Button size="sm" variant="outline" className="rounded-full" onClick={() => setOpen(open === m.contact_id ? null : m.contact_id)}>
                  {open === m.contact_id ? "Replier" : "Lire"}
                </Button>
              </div>
            </div>
            {open === m.contact_id && (
              <div className="mt-3 bg-slate-50 p-3 rounded-xl">
                <p className="text-sm whitespace-pre-line text-slate-700">{m.body}</p>
                <div className="mt-3 flex gap-2">
                  {m.status !== "read" && <Button size="sm" variant="outline" className="rounded-full" onClick={() => setSt(m.contact_id, "read")} data-testid={`contact-read-${m.contact_id}`}>Marquer lu</Button>}
                  {m.status !== "replied" && <Button size="sm" className="rounded-full bg-emerald-600 hover:bg-emerald-700" onClick={() => setSt(m.contact_id, "replied")} data-testid={`contact-replied-${m.contact_id}`}>Marquer répondu</Button>}
                  <a href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject)}`} className="inline-flex"><Button size="sm" className="rounded-full bg-sky-700 hover:bg-sky-600"><Mail className="w-3 h-3 mr-1" />Répondre par email</Button></a>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function AuditLogTab() {
  const [data, setData] = useState({ items: [], total: 0, page: 0, page_size: 50 });
  const [filters, setFilters] = useState({ action: "all", days: 30 });
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);

  const reload = async () => {
    setLoading(true);
    const params = { days: filters.days, page, page_size: pageSize };
    if (filters.action !== "all") params.action = filters.action;
    if (q.trim()) params.q = q.trim();
    try {
      const { data } = await api.get("/admin/audit", { params });
      setData(data);
    } catch (e) {
      toast.error("Chargement impossible");
    } finally { setLoading(false); }
  };
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, [filters.action, filters.days, page, pageSize]);
  // Server-side debounced search
  useEffect(() => {
    const t = setTimeout(() => { setPage(0); reload(); }, 350);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [q]);

  const ACTIONS = [
    "diploma_validate", "diploma_reject",
    "insurance_validate", "insurance_reject",
    "user_suspend", "user_reactivate", "user_delete", "user_update",
    "app_review_reply", "app_review_delete",
    "contact_read", "contact_replied",
    "pool_suggestion_approve", "pool_suggestion_reject", "pool_delete",
    "legal_update",
  ];

  const totalPages = Math.max(1, Math.ceil(data.total / pageSize));
  const items = data.items || [];

  return (
    <div data-testid="admin-audit">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <div className="relative flex-1 max-w-sm">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input placeholder="Nom / email / user_id (ex: DUPONT)…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-10" data-testid="adm-audit-search" />
        </div>
        <Label className="text-xs">Action</Label>
        <select className="border rounded-lg px-2 py-1 text-sm" value={filters.action} onChange={(e) => { setPage(0); setFilters({ ...filters, action: e.target.value }); }} data-testid="adm-audit-action">
          <option value="all">Toutes</option>
          {ACTIONS.map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
        <Label className="text-xs">Période</Label>
        <select className="border rounded-lg px-2 py-1 text-sm" value={filters.days} onChange={(e) => { setPage(0); setFilters({ ...filters, days: parseInt(e.target.value, 10) }); }} data-testid="adm-audit-days">
          {[7, 30, 90, 365].map((d) => <option key={d} value={d}>{d} jours</option>)}
        </select>
        <span className="ml-auto text-sm text-slate-500">{data.total} entrée{data.total > 1 ? "s" : ""}</span>
      </div>
      {loading ? <div className="card-soft p-6 text-center text-slate-500">Chargement…</div>
       : items.length === 0 ? (
        <div className="card-soft p-8 text-center text-slate-500">Aucune action enregistrée pour cette recherche.</div>
      ) : (
        <div className="card-soft overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500">
              <tr>
                <th className="text-left p-3">Date</th>
                <th className="text-left p-3">Acteur</th>
                <th className="text-left p-3">Action</th>
                <th className="text-left p-3">Cible</th>
                <th className="text-left p-3">Détails</th>
              </tr>
            </thead>
            <tbody>
              {items.map((l) => (
                <tr key={l.log_id} className="border-t hover:bg-slate-50" data-testid={`audit-row-${l.log_id}`}>
                  <td className="p-3 whitespace-nowrap text-xs">{new Date(l.created_at).toLocaleString("fr-FR")}</td>
                  <td className="p-3">{l.actor?.name || l.actor_name || "—"}<span className="text-xs text-slate-400 block">{l.actor?.email || l.actor_email}</span></td>
                  <td className="p-3"><span className="text-xs bg-sky-100 text-sky-700 px-2 py-0.5 rounded-full">{l.action}</span></td>
                  <td className="p-3 text-xs text-slate-600">
                    {l.target_type}
                    {l.target?.name ? <><br /><strong className="text-slate-800">{l.target.name}</strong></> : null}
                    {l.target_id && <span className="block text-slate-400">{l.target_id}</span>}
                  </td>
                  <td className="p-3 text-xs text-slate-600">{l.details ? <pre className="whitespace-pre-wrap font-mono text-[11px]">{JSON.stringify(l.details, null, 0)}</pre> : "—"}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Pagination */}
      <div className="flex items-center justify-between gap-3 flex-wrap text-sm mt-3">
        <div className="flex items-center gap-2">
          <Label className="text-xs">Par page</Label>
          <select value={pageSize} onChange={(e) => { setPageSize(parseInt(e.target.value, 10)); setPage(0); }} className="border border-slate-200 rounded-md px-2 py-1 text-sm" data-testid="adm-audit-page-size">
            {[10, 20, 50, 100].map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" className="rounded-full" disabled={page === 0} onClick={() => setPage((p) => Math.max(0, p - 1))} data-testid="adm-audit-prev">← Précédent</Button>
          <span className="text-slate-500 text-xs px-2">Page {page + 1} / {totalPages}</span>
          <Button variant="outline" size="sm" className="rounded-full" disabled={page >= totalPages - 1} onClick={() => setPage((p) => p + 1)} data-testid="adm-audit-next">Suivant →</Button>
        </div>
      </div>
    </div>
  );
}

function LegalAdminTab() {
  const [docs, setDocs] = useState([]);
  const [active, setActive] = useState("cgu");
  const [form, setForm] = useState({ title: "", body: "", version: "" });
  const [busy, setBusy] = useState(false);
  // Iter37 ter fix: confirm before broadcasting to avoid email-spam incidents.
  const [broadcastBusy, setBroadcastBusy] = useState(false);
  const [previewData, setPreviewData] = useState(null); // {will_notify, will_skip_recent_24h, total_users}
  const [confirmOpen, setConfirmOpen] = useState(false);

  const reload = async () => {
    const { data } = await api.get("/admin/legal");
    setDocs(data);
  };
  useEffect(() => { reload(); }, []);

  useEffect(() => {
    const d = docs.find((x) => x.slug === active);
    setForm({ title: d?.title || "", body: d?.body || "", version: d?.version || "" });
  }, [active, docs]);

  const save = async () => {
    if (!form.body.trim()) return toast.error("Le contenu ne peut pas être vide");
    setBusy(true);
    try {
      await api.put(`/admin/legal/${active}`, form);
      toast.success("Document mis à jour. Aucune notification envoyée — utilisez « Notifier les utilisateurs » pour diffuser.");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    finally { setBusy(false); }
  };

  const openBroadcastConfirm = async () => {
    if (!["cgu", "cgv"].includes(active)) return;
    setBroadcastBusy(true);
    try {
      const { data } = await api.get(`/admin/legal/${active}/broadcast/preview`);
      setPreviewData(data);
      setConfirmOpen(true);
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    finally { setBroadcastBusy(false); }
  };

  const confirmBroadcast = async () => {
    setBroadcastBusy(true);
    try {
      const { data } = await api.post(`/admin/legal/${active}/broadcast`);
      toast.success(`Diffusé à ${data.notified} utilisateur(s) — ${data.skipped_recent || 0} ignoré(s) (déjà notifié(s) <24h).`);
      setConfirmOpen(false);
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    finally { setBroadcastBusy(false); }
  };

  const SLUGS = [
    { slug: "cgu", label: "CGU" },
    { slug: "cgv", label: "CGV" },
    { slug: "privacy", label: "Confidentialité" },
    { slug: "mentions", label: "Mentions légales" },
  ];

  const preview = (slug) => window.open(`/legal/${slug}`, "_blank");
  const isLegalNotifiable = ["cgu", "cgv"].includes(active);

  return (
    <div className="space-y-4" data-testid="admin-legal">
      <div className="flex flex-wrap items-center gap-2">
        {SLUGS.map((s) => (
          <Button key={s.slug} size="sm" variant={active === s.slug ? "default" : "outline"}
            className={`rounded-full ${active === s.slug ? "bg-sky-700 hover:bg-sky-600" : ""}`}
            onClick={() => setActive(s.slug)} data-testid={`legal-tab-${s.slug}`}>
            <FileText className="w-3 h-3 mr-1" />{s.label}
          </Button>
        ))}
        <Button size="sm" variant="outline" className="rounded-full ml-auto" onClick={() => preview(active)}>
          <Eye className="w-3 h-3 mr-1" />Prévisualiser
        </Button>
      </div>
      <div className="card-soft p-5 space-y-3">
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <Label>Titre affiché</Label>
            <Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="legal-title" />
          </div>
          <div>
            <Label>Version</Label>
            <Input value={form.version} onChange={(e) => setForm({ ...form, version: e.target.value })} placeholder="Auto: année.mois.jour" data-testid="legal-version" />
          </div>
        </div>
        <div>
          <Label>Contenu <span className="text-red-500">*</span></Label>
          <Textarea value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} rows={22} className="font-mono text-xs" data-testid="legal-body" />
          <p className="text-[11px] text-slate-500 mt-1">Texte brut. Les retours à la ligne sont respectés sur la page publique.</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <Button onClick={save} disabled={busy} className="rounded-full bg-sky-700 hover:bg-sky-600" data-testid="legal-save">
            <Edit3 className="w-3 h-3 mr-1" />{busy ? "Enregistrement…" : "Enregistrer"}
          </Button>
          {isLegalNotifiable && (
            <Button onClick={openBroadcastConfirm} disabled={broadcastBusy} variant="outline"
                    className="rounded-full border-amber-300 text-amber-700 hover:bg-amber-50" data-testid="legal-broadcast">
              <Bell className="w-3 h-3 mr-1" />{broadcastBusy ? "Préparation…" : "Notifier les utilisateurs"}
            </Button>
          )}
          <span className="text-xs text-slate-500">
            {docs.find((d) => d.slug === active)?.updated_at
              ? `Dernière modification : ${new Date(docs.find((d) => d.slug === active).updated_at).toLocaleString("fr-FR")}`
              : "Jamais modifié (texte par défaut appliqué)"}
          </span>
        </div>
        {isLegalNotifiable && (
          <div className="text-[11px] text-slate-500 italic bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
            ℹ️ L'enregistrement <strong>ne déclenche plus</strong> automatiquement de notification (anti-spam).
            Cliquez sur « Notifier les utilisateurs » pour envoyer 1 email + 1 push à chaque utilisateur (rate-limité à 1 email / 24h / utilisateur).
          </div>
        )}
      </div>

      {/* Iter37 ter: broadcast confirmation dialog */}
      <Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
        <DialogContent data-testid="legal-broadcast-dialog">
          <DialogHeader>
            <DialogTitle>Notifier les utilisateurs ({active.toUpperCase()})</DialogTitle>
            <DialogDescription>
              {previewData ? (
                <span className="block mt-2 text-sm">
                  Version diffusée : <strong>{previewData.version || "(vide)"}</strong><br />
                  Total utilisateurs (hors admin) : <strong>{previewData.total_users}</strong><br />
                  Vont recevoir une notification + email : <strong className="text-emerald-700">{previewData.will_notify}</strong><br />
                  Ignorés (déjà notifiés &lt; 24h) : <strong className="text-amber-700">{previewData.will_skip_recent_24h}</strong>
                </span>
              ) : "Chargement…"}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" className="rounded-full" onClick={() => setConfirmOpen(false)}>Annuler</Button>
            <Button onClick={confirmBroadcast} disabled={broadcastBusy || (previewData?.will_notify || 0) === 0}
                    className="rounded-full bg-amber-600 hover:bg-amber-500 text-white" data-testid="legal-broadcast-confirm">
              {broadcastBusy ? "Envoi…" : `Confirmer l'envoi à ${previewData?.will_notify || 0} utilisateur(s)`}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

function OptionsTab() {
  const [options, setOptions] = useState([]);
  const [form, setForm] = useState({ name: "", description: "", price: 0, active: true });

  const reload = () => api.get("/admin/options").then((r) => setOptions(r.data));
  useEffect(() => { reload(); }, []);

  const add = async (e) => {
    e.preventDefault();
    await api.post("/admin/options", form);
    toast.success("Option ajoutée");
    setForm({ name: "", description: "", price: 0, active: true });
    reload();
  };
  const toggle = async (o) => { await api.put(`/admin/options/${o.option_id}`, { ...o, active: !o.active }); reload(); };
  const del = async (id) => { await api.delete(`/admin/options/${id}`); toast.success("Supprimé"); reload(); };

  return (
    <div className="grid lg:grid-cols-[400px_1fr] gap-6">
      <div className="card-soft p-6 h-fit">
        <h3 className="font-bold mb-3" style={{ fontFamily: "Outfit" }}>Nouvelle option payante</h3>
        <form onSubmit={add} className="space-y-3" data-testid="admin-option-form">
          <div><Label>Nom</Label><Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="opt-name" /></div>
          <div><Label>Description</Label><Textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
          <div><Label>Prix (€)</Label><Input type="number" step="0.01" required value={form.price} onChange={(e) => setForm({ ...form, price: parseFloat(e.target.value) })} data-testid="opt-price" /></div>
          <div className="flex items-center justify-between bg-slate-50 p-2 rounded-lg"><Label>Actif</Label><Switch checked={form.active} onCheckedChange={(v) => setForm({ ...form, active: v })} /></div>
          <Button type="submit" className="w-full rounded-full bg-sky-700 hover:bg-sky-600" data-testid="add-opt-btn"><Plus className="w-4 h-4 mr-1" />Ajouter</Button>
        </form>
      </div>
      <div className="space-y-3" data-testid="admin-options">
        {options.length === 0 && <div className="card-soft p-8 text-center text-slate-500">Aucune option payante</div>}
        {options.map((o) => (
          <div key={o.option_id} className="card-soft p-5 flex items-start justify-between flex-wrap gap-3">
            <div>
              <div className="font-semibold">{o.name} <span className="text-sky-700 ml-2">{o.price}€</span></div>
              <div className="text-sm text-slate-600">{o.description}</div>
              <div className="text-xs mt-1">{o.active ? <span className="text-emerald-700">Actif</span> : <span className="text-slate-500">Désactivé</span>}</div>
            </div>
            <div className="flex gap-2">
              <Switch checked={o.active} onCheckedChange={() => toggle(o)} />
              <Button size="icon" variant="ghost" onClick={() => del(o.option_id)}><Trash2 className="w-4 h-4 text-red-500" /></Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


function EmailDeliverabilityTab() {
  const [stats, setStats] = useState(null);
  const [days, setDays] = useState(30);
  const [testTo, setTestTo] = useState("");
  const [busy, setBusy] = useState(false);

  const reload = async () => {
    try {
      const { data } = await api.get("/admin/email-stats", { params: { days } });
      setStats(data);
    } catch (e) { toast.error("Chargement échoué"); }
  };
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, [days]);

  const sendTest = async () => {
    if (!testTo) return toast.error("Entrez une adresse email");
    setBusy(true);
    try {
      await api.post("/admin/email-stats/test", { to: testTo, subject: "Test délivrabilité MSL" });
      toast.success("Email de test envoyé");
      reload();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Échec envoi");
    } finally { setBusy(false); }
  };

  const retry = async (qid) => {
    try {
      const { data } = await api.post(`/admin/email-stats/${qid}/retry`);
      if (data.ok) toast.success("Renvoyé !");
      else toast.error(data.error || "Échec");
      reload();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    }
  };

  if (!stats) return <div className="card-soft p-8 text-center text-slate-500">Chargement…</div>;
  const t = stats.totals;
  const statusColor = (s) => s === "delivered" ? "bg-emerald-100 text-emerald-800"
    : s === "sent" ? "bg-emerald-50 text-emerald-700"
    : s === "opened" ? "bg-blue-100 text-blue-800"
    : s === "clicked" ? "bg-violet-100 text-violet-800"
    : s === "bounced" ? "bg-orange-100 text-orange-800"
    : s === "complained" ? "bg-red-100 text-red-800"
    : s === "failed" ? "bg-amber-100 text-amber-800"
    : s === "pending" ? "bg-sky-100 text-sky-800"
    : "bg-slate-200 text-slate-700";

  return (
    <div className="space-y-4" data-testid="email-deliverability-tab">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h2 className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>Délivrabilité Resend</h2>
        <div className="flex items-center gap-2">
          <Label className="text-xs">Période</Label>
          <select value={days} onChange={(e) => setDays(parseInt(e.target.value))} className="border rounded-lg px-2 py-1 text-sm" data-testid="email-stats-period">
            <option value="7">7 jours</option>
            <option value="30">30 jours</option>
            <option value="90">90 jours</option>
            <option value="365">1 an</option>
          </select>
          <Button size="sm" variant="outline" className="rounded-full" onClick={reload} data-testid="email-stats-refresh"><RefreshCw className="w-3 h-3 mr-1" />Rafraîchir</Button>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
        <div className="card-soft p-4 text-center">
          <div className="text-3xl font-bold text-sky-700">{t.total}</div>
          <div className="text-xs text-slate-500 mt-1">Total envoyés</div>
        </div>
        <div className="card-soft p-4 text-center">
          <div className="text-3xl font-bold text-emerald-700">{t.delivered ?? 0}</div>
          <div className="text-xs text-slate-500 mt-1">Délivrés (webhook)</div>
        </div>
        <div className="card-soft p-4 text-center">
          <div className="text-3xl font-bold text-orange-700">{t.bounced || 0}</div>
          <div className="text-xs text-slate-500 mt-1">Rejetés (bounce)</div>
        </div>
        <div className="card-soft p-4 text-center">
          <div className="text-3xl font-bold text-red-700">{t.complained || 0}</div>
          <div className="text-xs text-slate-500 mt-1">Spam (plainte)</div>
        </div>
        <div className="card-soft p-4 text-center">
          <div className="text-3xl font-bold text-slate-500">{t.suppressed_users || 0}</div>
          <div className="text-xs text-slate-500 mt-1">Adresses bloquées</div>
        </div>
        <div className="card-soft p-4 text-center">
          <div className="text-3xl font-bold text-sky-700">{stats.delivery_rate}%</div>
          <div className="text-xs text-slate-500 mt-1">Taux de délivrance</div>
        </div>
      </div>

      <div className="card-soft p-5">
        <h3 className="font-semibold mb-3" style={{ fontFamily: "Outfit" }}>Test d'envoi</h3>
        <div className="flex flex-wrap gap-2 items-end">
          <div className="flex-1 min-w-[240px]">
            <Label className="text-xs">Destinataire</Label>
            <Input
              type="email" placeholder="test@gmail.com"
              value={testTo} onChange={(e) => setTestTo(e.target.value)}
              data-testid="email-test-to"
            />
          </div>
          <Button onClick={sendTest} disabled={busy || !testTo} className="rounded-full bg-sky-700 hover:bg-sky-600" data-testid="email-test-send">
            <Send className="w-3 h-3 mr-1" />{busy ? "Envoi…" : "Envoyer un test"}
          </Button>
        </div>
        <p className="text-xs text-slate-500 mt-2">
          ⚠️ Vérifiez que <code>contact@myswimminglessons.fr</code> est l'expéditeur visible. Si l'email est marqué spam, ajoutez l'adresse à vos contacts.
        </p>
      </div>

      <div className="card-soft p-5">
        <h3 className="font-semibold mb-3" style={{ fontFamily: "Outfit" }}>Par type de notification</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs text-slate-500 uppercase">
              <tr><th className="text-left py-2">Type</th><th>Délivrés</th><th>Échec</th><th>En attente</th><th>Abandonnés</th></tr>
            </thead>
            <tbody>
              {Object.entries(stats.by_kind).length === 0 && (
                <tr><td colSpan={5} className="text-center py-4 text-slate-500">Aucune donnée sur la période</td></tr>
              )}
              {Object.entries(stats.by_kind).map(([k, v]) => (
                <tr key={k} className="border-t">
                  <td className="py-2 font-medium">{k}</td>
                  <td className="text-center text-emerald-700">{v.sent || 0}</td>
                  <td className="text-center text-amber-700">{v.failed || 0}</td>
                  <td className="text-center text-sky-700">{v.pending || 0}</td>
                  <td className="text-center text-red-700">{v.abandoned || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card-soft p-5">
        <h3 className="font-semibold mb-3" style={{ fontFamily: "Outfit" }}>Derniers envois</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs text-slate-500 uppercase">
              <tr><th className="text-left py-2">Date</th><th className="text-left">Destinataire</th><th className="text-left">Type</th><th className="text-left">Sujet</th><th>Statut</th><th></th></tr>
            </thead>
            <tbody>
              {stats.recent.length === 0 && (
                <tr><td colSpan={6} className="text-center py-4 text-slate-500">Aucun email récent</td></tr>
              )}
              {stats.recent.map((r) => (
                <tr key={r.queue_id} className="border-t" data-testid={`email-row-${r.queue_id}`}>
                  <td className="py-2 text-xs text-slate-500 whitespace-nowrap">{new Date(r.created_at).toLocaleString("fr-FR")}</td>
                  <td className="text-xs">{r.to}</td>
                  <td className="text-xs">{r.kind || "—"}</td>
                  <td className="text-xs max-w-[260px] truncate" title={r.subject}>{r.subject}</td>
                  <td className="text-center">
                    <span className={`text-xs px-2 py-0.5 rounded-full ${statusColor(r.status)}`}>{r.status}</span>
                    {r.error && <div className="text-[10px] text-red-700 mt-1 max-w-[200px] truncate" title={r.error}>{r.error}</div>}
                  </td>
                  <td>
                    {(r.status === "failed" || r.status === "abandoned") && (
                      <Button size="sm" variant="ghost" className="h-7 px-2" onClick={() => retry(r.queue_id)} data-testid={`email-retry-${r.queue_id}`} title="Réessayer">
                        <RefreshCw className="w-3 h-3" />
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function ConnectAdminTab() {
  const [data, setData] = useState(null);
  const reload = async () => {
    try {
      const { data: d } = await api.get("/admin/connect-overview");
      setData(d);
    } catch { toast.error("Chargement échoué"); }
  };
  useEffect(() => { reload(); }, []);

  if (!data) return <div className="card-soft p-8 text-center text-slate-500">Chargement…</div>;

  const statusBadge = (s) => {
    if (s === "active") return <span className="text-xs px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800">Actif</span>;
    if (s === "onboarding_incomplete") return <span className="text-xs px-2 py-0.5 rounded-full bg-amber-100 text-amber-800">Incomplet</span>;
    if (s === "onboarding_started") return <span className="text-xs px-2 py-0.5 rounded-full bg-sky-100 text-sky-800">En cours</span>;
    return <span className="text-xs px-2 py-0.5 rounded-full bg-slate-200 text-slate-700">Non configuré</span>;
  };
  const withdrawalBadge = (s) => {
    if (s === "paid") return <span className="text-xs px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800">Payé</span>;
    if (s === "pending") return <span className="text-xs px-2 py-0.5 rounded-full bg-sky-100 text-sky-800">En cours</span>;
    if (s === "failed") return <span className="text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-800">Échec</span>;
    return <span className="text-xs px-2 py-0.5 rounded-full bg-slate-200 text-slate-700">{s}</span>;
  };

  return (
    <div className="space-y-4" data-testid="connect-admin-tab">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>Stripe Connect — Vue d'ensemble</h2>
        <Button size="sm" variant="outline" className="rounded-full" onClick={reload} data-testid="connect-admin-refresh">
          <RefreshCw className="w-3 h-3 mr-1" />Rafraîchir
        </Button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div className="card-soft p-4 text-center">
          <div className="text-3xl font-bold text-sky-700">{data.summary.total_mns}</div>
          <div className="text-xs text-slate-500 mt-1">MNS avec compte</div>
        </div>
        <div className="card-soft p-4 text-center">
          <div className="text-3xl font-bold text-emerald-700">{data.summary.active}</div>
          <div className="text-xs text-slate-500 mt-1">Actifs</div>
        </div>
        <div className="card-soft p-4 text-center">
          <div className="text-3xl font-bold text-amber-700">{data.summary.incomplete}</div>
          <div className="text-xs text-slate-500 mt-1">Onboarding incomplet</div>
        </div>
        <div className="card-soft p-4 text-center">
          <div className="text-3xl font-bold text-sky-700">{data.summary.started}</div>
          <div className="text-xs text-slate-500 mt-1">En cours</div>
        </div>
      </div>

      <div className="card-soft p-5">
        <h3 className="font-semibold mb-3" style={{ fontFamily: "Outfit" }}>Maîtres-nageurs</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs text-slate-500 uppercase">
              <tr>
                <th className="text-left py-2">MNS</th>
                <th className="text-left">Compte Stripe</th>
                <th className="text-left">Statut</th>
                <th className="text-left">Exigences</th>
                <th className="text-right">Versements</th>
                <th className="text-right">Total versé</th>
              </tr>
            </thead>
            <tbody>
              {data.mns.length === 0 && (
                <tr><td colSpan={6} className="text-center py-6 text-slate-500">Aucun MNS n'a encore démarré l'onboarding Stripe Connect.</td></tr>
              )}
              {data.mns.map((m) => (
                <tr key={m.user_id} className="border-t" data-testid={`connect-mns-row-${m.user_id}`}>
                  <td className="py-2">
                    <div className="font-medium">{m.name}</div>
                    <div className="text-xs text-slate-500">{m.email}</div>
                  </td>
                  <td className="text-xs font-mono text-slate-600">{m.stripe_account_id}</td>
                  <td>{statusBadge(m.status)}</td>
                  <td className="text-xs">
                    {(m.requirements || []).length === 0 ? (
                      <span className="text-emerald-700">—</span>
                    ) : (
                      <span className="text-amber-700" title={m.requirements.join(", ")}>
                        {m.requirements.length} champ{m.requirements.length > 1 ? "s" : ""}
                      </span>
                    )}
                  </td>
                  <td className="text-right text-xs">{m.withdrawals.paid}/{m.withdrawals.count}</td>
                  <td className="text-right font-semibold">{m.withdrawals.total_eur.toFixed(2)}€</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card-soft p-5">
        <h3 className="font-semibold mb-3" style={{ fontFamily: "Outfit" }}>30 derniers versements</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs text-slate-500 uppercase">
              <tr>
                <th className="text-left py-2">Date</th>
                <th className="text-left">MNS</th>
                <th className="text-right">Montant</th>
                <th className="text-left">Statut</th>
                <th className="text-left">Transfer ID</th>
              </tr>
            </thead>
            <tbody>
              {data.recent_withdrawals.length === 0 && (
                <tr><td colSpan={5} className="text-center py-6 text-slate-500">Aucun versement pour le moment.</td></tr>
              )}
              {data.recent_withdrawals.map((w) => (
                <tr key={w.withdrawal_id} className="border-t" data-testid={`connect-wd-row-${w.withdrawal_id}`}>
                  <td className="py-2 text-xs text-slate-500 whitespace-nowrap">{new Date(w.created_at).toLocaleString("fr-FR")}</td>
                  <td className="text-sm">{w.mns_name}</td>
                  <td className="text-right font-semibold">{w.amount.toFixed(2)}€</td>
                  <td>{withdrawalBadge(w.status)}</td>
                  <td className="text-xs font-mono text-slate-500">{w.stripe_transfer_id}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ---- Sanctions Tab (Iter37 Vague 1) ----
function SanctionsTab() {
  const [data, setData] = useState({ items: [], total: 0 });
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const [openSanction, setOpenSanction] = useState(false);
  const [target, setTarget] = useState({ user_id: "", email: "" });
  const [form, setForm] = useState({ sanction_type: "spam", duration_days: 7, reason: "" });

  const reload = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/sanctions", { params: { page, page_size: pageSize } });
      setData(data || { items: [], total: 0 });
    } catch (e) { toast.error(e.response?.data?.detail || "Chargement impossible"); }
    finally { setLoading(false); }
  };
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, [page, pageSize]);

  const apply = async () => {
    if (!target.user_id) return toast.error("Sélectionnez un utilisateur (user_id requis)");
    if (!form.reason.trim()) return toast.error("Motif requis");
    try {
      await api.post(`/admin/sanctions/apply`, {
        user_id: target.user_id,
        sanction_type: form.sanction_type,
        duration_days: parseInt(form.duration_days, 10),
        reason: form.reason.trim(),
      });
      toast.success("Sanction appliquée");
      setOpenSanction(false);
      setForm({ sanction_type: "spam", duration_days: 7, reason: "" });
      setTarget({ user_id: "", email: "" });
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  const totalPages = Math.max(1, Math.ceil((data.total || 0) / pageSize));
  const items = data.items || [];

  return (
    <div data-testid="admin-sanctions">
      <div className="flex items-center justify-between mb-4 gap-2 flex-wrap">
        <h2 className="text-xl font-bold flex items-center gap-2"><ShieldOff className="w-5 h-5 text-rose-600" />Sanctions ({data.total || 0})</h2>
        <Button className="rounded-full bg-rose-600 hover:bg-rose-700" onClick={() => setOpenSanction(true)} data-testid="adm-sanction-apply-btn">
          <ShieldOff className="w-4 h-4 mr-1" />Appliquer une sanction
        </Button>
      </div>

      {loading ? <div className="card-soft p-6 text-center text-slate-500">Chargement…</div>
        : items.length === 0 ? (
          <div className="card-soft p-8 text-center text-slate-500" data-testid="adm-sanction-empty">Aucune sanction enregistrée.</div>
        ) : (
          <div className="card-soft overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500">
                <tr>
                  <th className="text-left p-3">Date</th>
                  <th className="text-left p-3">Type</th>
                  <th className="text-left p-3">Utilisateur visé</th>
                  <th className="text-left p-3">Acteur</th>
                  <th className="text-left p-3">Motif / Détails</th>
                </tr>
              </thead>
              <tbody>
                {items.map((l) => (
                  <tr key={l.log_id} className="border-t hover:bg-slate-50" data-testid={`sanction-row-${l.log_id}`}>
                    <td className="p-3 whitespace-nowrap text-xs">{new Date(l.created_at).toLocaleString("fr-FR")}</td>
                    <td className="p-3"><span className="text-xs bg-rose-100 text-rose-700 px-2 py-0.5 rounded-full">{l.action}</span></td>
                    <td className="p-3 text-xs">
                      <div className="font-medium">{l.target?.name || "—"}</div>
                      <div className="text-slate-500">{l.target?.email}</div>
                      <div className="text-slate-400 text-[11px]">{l.target_id}</div>
                    </td>
                    <td className="p-3 text-xs">{l.actor?.name || "—"}<span className="block text-slate-500">{l.actor?.email}</span></td>
                    <td className="p-3 text-xs text-slate-700">
                      {l.details?.sanction_type && <span className="inline-block bg-amber-100 text-amber-800 px-2 py-0.5 rounded-full mr-1">{l.details.sanction_type}</span>}
                      {l.details?.duration_days != null && <span className="inline-block bg-slate-100 text-slate-700 px-2 py-0.5 rounded-full mr-1">{l.details.duration_days}j</span>}
                      {l.details?.reason && <div className="mt-1">{l.details.reason}</div>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

      <div className="flex items-center justify-between gap-3 flex-wrap text-sm mt-3">
        <div className="flex items-center gap-2">
          <Label className="text-xs">Par page</Label>
          <select value={pageSize} onChange={(e) => { setPageSize(parseInt(e.target.value, 10)); setPage(0); }} className="border border-slate-200 rounded-md px-2 py-1 text-sm" data-testid="adm-sanction-page-size">
            {[10, 20, 50, 100].map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" className="rounded-full" disabled={page === 0} onClick={() => setPage((p) => Math.max(0, p - 1))} data-testid="adm-sanction-prev">← Précédent</Button>
          <span className="text-slate-500 text-xs px-2">Page {page + 1} / {totalPages}</span>
          <Button variant="outline" size="sm" className="rounded-full" disabled={page >= totalPages - 1} onClick={() => setPage((p) => p + 1)} data-testid="adm-sanction-next">Suivant →</Button>
        </div>
      </div>

      <Dialog open={openSanction} onOpenChange={setOpenSanction}>
        <DialogContent data-testid="adm-sanction-dialog">
          <DialogHeader><DialogTitle>Appliquer une sanction</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div>
              <Label className="text-xs">Email ou user_id</Label>
              <Input
                value={target.user_id}
                onChange={(e) => setTarget({ ...target, user_id: e.target.value })}
                placeholder="user_id (ex: usr_abc123) ou email"
                data-testid="adm-sanction-user"
              />
              <div className="text-xs text-slate-500 mt-1">Astuce : copiez l'user_id depuis l'onglet Utilisateurs.</div>
            </div>
            <div>
              <Label className="text-xs">Type de sanction</Label>
              <select value={form.sanction_type} onChange={(e) => setForm({ ...form, sanction_type: e.target.value })} className="w-full border rounded-lg px-2 py-2 text-sm" data-testid="adm-sanction-type">
                <option value="spam">Spam / Comportement abusif</option>
                <option value="fraude">Fraude</option>
                <option value="no_show_recurrent">No-show récurrents</option>
                <option value="fake_docs">Faux documents</option>
                <option value="harassment">Harcèlement</option>
                <option value="other">Autre</option>
              </select>
            </div>
            <div>
              <Label className="text-xs">Durée</Label>
              <select value={form.duration_days} onChange={(e) => setForm({ ...form, duration_days: e.target.value })} className="w-full border rounded-lg px-2 py-2 text-sm" data-testid="adm-sanction-duration">
                <option value={7}>7 jours</option>
                <option value={30}>30 jours</option>
                <option value={90}>90 jours</option>
                <option value={0}>Permanent</option>
              </select>
            </div>
            <div>
              <Label className="text-xs">Motif détaillé (visible dans le journal)</Label>
              <Textarea value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} rows={3} data-testid="adm-sanction-reason" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" className="rounded-full" onClick={() => setOpenSanction(false)}>Annuler</Button>
            <Button className="rounded-full bg-rose-600 hover:bg-rose-700" onClick={apply} data-testid="adm-sanction-confirm">Appliquer</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

// ---- Tests Emergent Tab (Iter37 Vague 1) ----
function TestsEmergentTab() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [purging, setPurging] = useState(false);

  const reload = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/users", { params: { include_hidden: true, limit: 1000 } });
      setUsers((data || []).filter((u) => u.hidden === true));
    } catch { toast.error("Chargement impossible"); }
    finally { setLoading(false); }
  };
  useEffect(() => { reload(); }, []);

  const toggleHidden = async (uid, currentlyHidden) => {
    try {
      await api.post(`/admin/users/${uid}/visibility`, { hidden: !currentlyHidden });
      toast.success(!currentlyHidden ? "Marqué comme test (masqué)" : "Restauré (visible)");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  const purgeAll = async () => {
    if (!window.confirm(`Supprimer DÉFINITIVEMENT ${users.length} comptes test ? Action irréversible.`)) return;
    setPurging(true);
    try {
      const { data } = await api.post(`/admin/tests/purge`);
      toast.success(`${data.deleted || 0} comptes purgés`);
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    finally { setPurging(false); }
  };

  return (
    <div data-testid="admin-tests-emergent" className="space-y-4">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div>
          <h2 className="text-xl font-bold flex items-center gap-2"><FlaskConical className="w-5 h-5 text-violet-600" />Tests Emergent ({users.length})</h2>
          <p className="text-sm text-slate-500 mt-1">Comptes générés par les agents de test, masqués des stats publiques. Vous pouvez purger ou restaurer.</p>
        </div>
        <Button variant="outline" className="rounded-full border-rose-300 text-rose-700 hover:bg-rose-50" onClick={purgeAll} disabled={purging || users.length === 0} data-testid="adm-tests-purge">
          <Trash2 className="w-4 h-4 mr-1" />Purger tous les comptes test
        </Button>
      </div>

      {loading ? <div className="card-soft p-6 text-center text-slate-500">Chargement…</div>
        : users.length === 0 ? (
          <div className="card-soft p-8 text-center text-slate-500" data-testid="adm-tests-empty">Aucun compte test détecté.</div>
        ) : (
          <div className="card-soft overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500">
                <tr>
                  <th className="text-left p-3">Nom / Email</th>
                  <th className="text-left p-3">Rôle</th>
                  <th className="text-left p-3">Inscription</th>
                  <th className="text-left p-3">Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((u) => (
                  <tr key={u.user_id} className="border-t hover:bg-slate-50" data-testid={`test-user-${u.user_id}`}>
                    <td className="p-3"><div className="font-medium">{u.name || "—"}</div><div className="text-xs text-slate-500">{u.email}</div></td>
                    <td className="p-3 text-xs"><span className="bg-slate-100 text-slate-700 px-2 py-0.5 rounded-full">{u.role}</span></td>
                    <td className="p-3 text-xs text-slate-500">{u.created_at ? new Date(u.created_at).toLocaleDateString("fr-FR") : "—"}</td>
                    <td className="p-3">
                      <Button variant="outline" size="sm" className="rounded-full" onClick={() => toggleHidden(u.user_id, true)} data-testid={`test-restore-${u.user_id}`}>
                        <Eye className="w-3.5 h-3.5 mr-1" />Restaurer
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
}

// ---- Iter37 octies: System Health Tab ----
function StatusPill({ status }) {
  if (status === "ok") return <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-medium"><CheckCircle2 className="w-3 h-3" />OK</span>;
  if (status === "warning") return <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 text-xs font-medium"><AlertTriangle className="w-3 h-3" />Avertissement</span>;
  return <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-red-100 text-red-700 text-xs font-medium"><AlertCircle className="w-3 h-3" />Erreur</span>;
}

function ComponentCard({ name, comp }) {
  const det = comp.details || {};
  return (
    <div className="card-soft p-4 border-l-4" style={{ borderColor: comp.status === "ok" ? "#10b981" : comp.status === "warning" ? "#f59e0b" : "#dc2626" }} data-testid={`health-comp-${name}`}>
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h3 className="font-semibold text-slate-800" style={{ fontFamily: "Outfit" }}>{comp.label}</h3>
        <StatusPill status={comp.status} />
      </div>
      {comp.error && <p className="mt-2 text-sm text-red-700 bg-red-50 px-3 py-2 rounded-lg" data-testid={`health-error-${name}`}>{comp.error}</p>}
      {comp.warning && <p className="mt-2 text-sm text-amber-800 bg-amber-50 px-3 py-2 rounded-lg" data-testid={`health-warn-${name}`}>{comp.warning}</p>}
      {Object.keys(det).length > 0 && (
        <dl className="mt-3 grid grid-cols-2 gap-x-3 gap-y-1 text-xs">
          {Object.entries(det).map(([k, v]) => (
            <React.Fragment key={k}>
              <dt className="text-slate-500 truncate">{k}</dt>
              <dd className="text-slate-800 font-mono truncate">
                {typeof v === "boolean" ? (v ? "✓" : "✗")
                  : typeof v === "object" ? JSON.stringify(v).slice(0, 60)
                  : String(v).slice(0, 80)}
              </dd>
            </React.Fragment>
          ))}
        </dl>
      )}
    </div>
  );
}

function SystemHealthTab() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [autoRefresh, setAutoRefresh] = useState(false);

  const reload = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/system/health");
      setData(data);
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    finally { setLoading(false); }
  };

  useEffect(() => { reload(); }, []);
  useEffect(() => {
    if (!autoRefresh) return undefined;
    const id = setInterval(reload, 30000); // 30s
    return () => clearInterval(id);
  }, [autoRefresh]);

  if (loading && !data) return <div className="card-soft p-8 text-center text-slate-500" data-testid="health-loading">Diagnostic en cours…</div>;
  if (!data) return null;

  const overall = data.overall;
  const overallText = overall === "ok" ? "Tous les systèmes sont opérationnels"
                      : overall === "warning" ? "Certains composants nécessitent votre attention"
                      : "Un ou plusieurs composants critiques sont en erreur";
  const overallClass = overall === "ok" ? "bg-emerald-50 border-emerald-300 text-emerald-900"
                       : overall === "warning" ? "bg-amber-50 border-amber-300 text-amber-900"
                       : "bg-red-50 border-red-300 text-red-900";

  return (
    <div className="space-y-4" data-testid="admin-system-health">
      <div className={`card-soft p-5 border-2 ${overallClass} flex items-center justify-between gap-3 flex-wrap`}>
        <div className="flex items-center gap-3">
          <Activity className="w-7 h-7 shrink-0" />
          <div>
            <h2 className="text-xl font-bold" style={{ fontFamily: "Outfit" }} data-testid="health-overall-text">{overallText}</h2>
            <p className="text-xs opacity-75 mt-1">Diagnostic effectué : {new Date(data.checked_at).toLocaleString("fr-FR")}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <label className="text-sm flex items-center gap-2 cursor-pointer" title="Rafraîchit toutes les 30 secondes">
            <input type="checkbox" checked={autoRefresh} onChange={(e) => setAutoRefresh(e.target.checked)} data-testid="health-autorefresh" />
            Auto-actualiser
          </label>
          <Button onClick={reload} disabled={loading} variant="outline" className="rounded-full" data-testid="health-refresh">
            <RefreshCw className={`w-3 h-3 mr-1 ${loading ? "animate-spin" : ""}`} />Rafraîchir
          </Button>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-3">
        {Object.entries(data.components).map(([name, comp]) => (
          <ComponentCard key={name} name={name} comp={comp} />
        ))}
      </div>

      <EmailQueuePurgeCard onChanged={reload} />

      <div className="card-soft p-4 bg-slate-50">
        <h4 className="font-semibold text-sm mb-2">💡 Aide rapide</h4>
        <ul className="text-xs text-slate-700 space-y-1 list-disc pl-4">
          <li><strong>Stripe en erreur</strong> → Définir <code className="bg-white px-1 rounded">STRIPE_API_KEY</code> (sk_live_… ou sk_test_…) dans les variables d'environnement de la plateforme de déploiement, puis redéployer.</li>
          <li><strong>Resend en erreur</strong> → Définir <code className="bg-white px-1 rounded">RESEND_API_KEY</code> + <code className="bg-white px-1 rounded">SENDER_EMAIL</code> (domaine vérifié sur resend.com).</li>
          <li><strong>File d'attente bloquée &gt; 24h</strong> → Cliquez « Inspecter » ci-dessus pour voir le détail (par type d'email et destinataire), puis « Purger » pour nettoyer la file.</li>
          <li><strong>MongoDB en erreur</strong> → Contactez Emergent Support, problème côté infrastructure.</li>
          <li><strong>Variables critiques manquantes</strong> → Console de déploiement → Variables d'environnement.</li>
        </ul>
      </div>
    </div>
  );
}

function EmailQueuePurgeCard({ onChanged }) {
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hours, setHours] = useState(24);
  const [busy, setBusy] = useState(false);
  const [confirm, setConfirm] = useState(null); // { mode: 'abandon'|'delete' }

  const inspect = async () => {
    setLoading(true);
    setOpen(true);
    try {
      const { data } = await api.get("/admin/email-queue/stuck", { params: { older_than_hours: hours } });
      setDetails(data);
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    finally { setLoading(false); }
  };

  const doPurge = async (mode) => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/email-queue/purge", {
        older_than_hours: hours,
        statuses: ["pending", "failed"],
        mode,
      });
      toast.success(`${data.affected} email(s) ${mode === "delete" ? "supprimé(s)" : "abandonné(s)"} sur ${data.matched} détecté(s)`);
      setConfirm(null);
      setDetails(null);
      setOpen(false);
      onChanged?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card-soft p-4 border" data-testid="email-queue-purge-card">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h3 className="font-semibold text-sm flex items-center gap-2"><Mail className="w-4 h-4" />Maintenance file d'attente emails</h3>
          <p className="text-xs text-slate-500 mt-1">Inspectez les emails bloqués (pending/failed) puis abandonnez-les ou supprimez-les définitivement.</p>
        </div>
        <div className="flex items-center gap-2">
          <Label className="text-xs">Plus vieux que (h)</Label>
          <Input type="number" min={1} max={720} value={hours} onChange={(e) => setHours(Number(e.target.value) || 24)} className="w-20 h-9" data-testid="eq-hours" />
          <Button size="sm" variant="outline" className="rounded-full" onClick={inspect} disabled={loading} data-testid="eq-inspect">
            <Eye className="w-3 h-3 mr-1" />Inspecter
          </Button>
        </div>
      </div>

      <Dialog open={open} onOpenChange={(v) => !v && setOpen(false)}>
        <DialogContent className="max-w-3xl">
          <DialogHeader>
            <DialogTitle>Emails bloqués depuis plus de {hours}h</DialogTitle>
            <DialogDescription>
              {details ? <>Total détecté : <strong>{details.total_stuck}</strong> · Affichés : {details.returned}</> : "Chargement…"}
            </DialogDescription>
          </DialogHeader>
          {loading || !details ? (
            <div className="p-8 text-center text-slate-500">Chargement…</div>
          ) : (
            <div className="space-y-3 max-h-[60vh] overflow-y-auto">
              <div className="grid sm:grid-cols-2 gap-3">
                <div className="card-soft p-3">
                  <h4 className="text-xs uppercase tracking-widest text-slate-500 mb-2">Par type</h4>
                  {details.by_kind.length === 0 ? <p className="text-sm text-slate-400">Aucun</p> : (
                    <ul className="text-sm space-y-1">
                      {details.by_kind.map((k) => (
                        <li key={k.kind} className="flex justify-between"><span>{k.kind}</span><strong>{k.count}</strong></li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="card-soft p-3">
                  <h4 className="text-xs uppercase tracking-widest text-slate-500 mb-2">Top destinataires</h4>
                  {details.top_recipients.length === 0 ? <p className="text-sm text-slate-400">Aucun</p> : (
                    <ul className="text-sm space-y-1">
                      {details.top_recipients.map((r) => (
                        <li key={r.email} className="flex justify-between gap-2">
                          <span className="truncate">{r.email}</span><strong>{r.count}</strong>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>

              <details className="card-soft p-3">
                <summary className="cursor-pointer text-xs font-semibold text-slate-700">Voir les {Math.min(details.items.length, 50)} premiers emails</summary>
                <div className="mt-2 overflow-x-auto">
                  <table className="w-full text-xs">
                    <thead className="bg-slate-50 text-[10px] uppercase tracking-widest text-slate-500">
                      <tr>
                        <th className="text-left p-2">Date</th>
                        <th className="text-left p-2">Destinataire</th>
                        <th className="text-left p-2">Type</th>
                        <th className="text-left p-2">Sujet</th>
                        <th className="text-left p-2">Statut</th>
                        <th className="text-left p-2">Erreur</th>
                      </tr>
                    </thead>
                    <tbody>
                      {details.items.slice(0, 50).map((it) => (
                        <tr key={it.queue_id} className="border-t">
                          <td className="p-2 whitespace-nowrap">{new Date(it.created_at).toLocaleString("fr-FR")}</td>
                          <td className="p-2 truncate max-w-[180px]">{it.to}</td>
                          <td className="p-2">{it.kind || "—"}</td>
                          <td className="p-2 truncate max-w-[200px]">{it.subject || "—"}</td>
                          <td className="p-2"><span className={`px-2 py-0.5 rounded-full ${it.status === "failed" ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-800"}`}>{it.status}</span></td>
                          <td className="p-2 text-slate-500 truncate max-w-[220px]">{it.error || "—"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </details>

              <div className="flex flex-wrap gap-2 justify-end pt-2 border-t">
                <Button variant="outline" className="rounded-full" onClick={() => setOpen(false)} data-testid="eq-cancel">Fermer</Button>
                <Button variant="outline" className="rounded-full" onClick={() => setConfirm({ mode: "abandon" })} disabled={details.total_stuck === 0} data-testid="eq-abandon">
                  Marquer comme abandonnés ({details.total_stuck})
                </Button>
                <Button className="rounded-full bg-red-600 hover:bg-red-700 text-white" onClick={() => setConfirm({ mode: "delete" })} disabled={details.total_stuck === 0} data-testid="eq-delete">
                  <Trash2 className="w-3 h-3 mr-1" />Supprimer définitivement ({details.total_stuck})
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      <Dialog open={!!confirm} onOpenChange={(v) => !v && setConfirm(null)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Confirmer la {confirm?.mode === "delete" ? "suppression définitive" : "mise en abandon"}</DialogTitle>
            <DialogDescription>
              {confirm?.mode === "delete"
                ? "Les emails seront supprimés de la file d'attente. Cette action est irréversible."
                : "Les emails seront marqués comme abandonnés (status=abandoned). Ils ne seront plus relancés mais resteront en base pour audit."}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" className="rounded-full" onClick={() => setConfirm(null)}>Annuler</Button>
            <Button
              className={`rounded-full ${confirm?.mode === "delete" ? "bg-red-600 hover:bg-red-700" : "bg-amber-600 hover:bg-amber-700"} text-white`}
              onClick={() => doPurge(confirm.mode)} disabled={busy}
              data-testid="eq-confirm"
            >
              {busy ? "En cours…" : "Confirmer"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

// ---- Iter37 duodecies: Subscriptions Admin Tab ----
function SubStatusPill({ status }) {
  const map = {
    active: { cls: "bg-emerald-100 text-emerald-700", label: "Actif" },
    trialing: { cls: "bg-sky-100 text-sky-700", label: "Essai" },
    past_due: { cls: "bg-amber-100 text-amber-800", label: "Impayé" },
    canceled: { cls: "bg-slate-200 text-slate-600", label: "Résilié" },
    incomplete: { cls: "bg-red-100 text-red-700", label: "Incomplet" },
  };
  const m = map[status] || { cls: "bg-slate-100 text-slate-600", label: status || "—" };
  return <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${m.cls}`}>{m.label}</span>;
}

function SubscriptionsAdminTab() {
  const [data, setData] = useState({ items: [], total: 0, summary: { total: 0 } });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const [plan, setPlan] = useState("");
  const [includeHidden, setIncludeHidden] = useState(false);
  const [busyId, setBusyId] = useState(null);

  const reload = async () => {
    setLoading(true);
    try {
      const params = { page, page_size: pageSize, include_hidden: includeHidden };
      if (q.trim()) params.q = q.trim();
      if (status) params.status = status;
      if (plan) params.plan = plan;
      const { data } = await api.get("/admin/subscriptions", { params });
      setData(data);
    } catch (e) { toast.error(e.response?.data?.detail || "Chargement impossible"); }
    finally { setLoading(false); }
  };
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, [page, pageSize, status, plan, includeHidden]);

  const onSearch = (e) => { e.preventDefault(); setPage(0); reload(); };

  const resync = async (uid) => {
    setBusyId(uid);
    try {
      const { data: r } = await api.post(`/admin/subscriptions/${uid}/resync`);
      toast.success(`Resynchronisé : ${r.status}${r.active ? " (Premium actif ✓)" : ""}`);
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    finally { setBusyId(null); }
  };

  const exportCsv = () => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/admin/subscriptions/export.csv`;
    window.open(url, "_blank");
  };

  const totalPages = Math.max(1, Math.ceil((data.total || 0) / pageSize));
  const summary = data.summary || { active: 0, trialing: 0, past_due: 0, canceled: 0, incomplete: 0, total: 0 };

  return (
    <div data-testid="admin-subscriptions" className="space-y-4">
      {/* Summary cards */}
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
        {[
          { key: "active", label: "Actifs", color: "bg-emerald-50 border-emerald-200 text-emerald-800" },
          { key: "trialing", label: "Essai", color: "bg-sky-50 border-sky-200 text-sky-800" },
          { key: "past_due", label: "Impayés", color: "bg-amber-50 border-amber-200 text-amber-800" },
          { key: "canceled", label: "Résiliés", color: "bg-slate-50 border-slate-200 text-slate-700" },
          { key: "incomplete", label: "Incomplets", color: "bg-red-50 border-red-200 text-red-800" },
        ].map((s) => (
          <button key={s.key} onClick={() => { setStatus(s.key === status ? "" : s.key); setPage(0); }}
                  className={`card-soft p-3 border-2 text-left transition ${s.color} ${status === s.key ? "ring-2 ring-offset-1 ring-sky-400" : "hover:scale-[1.02]"}`}
                  data-testid={`sub-summary-${s.key}`}>
            <div className="text-2xl font-bold">{summary[s.key] || 0}</div>
            <div className="text-xs uppercase tracking-wider">{s.label}</div>
          </button>
        ))}
      </div>

      {/* Toolbar */}
      <div className="flex items-center gap-2 flex-wrap">
        <form onSubmit={onSearch} className="flex items-center gap-2">
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Email, nom, téléphone, user_id…"
                 className="w-72" data-testid="sub-search-input" />
          <Button type="submit" size="sm" variant="outline" className="rounded-full" data-testid="sub-search-btn">
            <Search className="w-3 h-3 mr-1" />Rechercher
          </Button>
        </form>
        <select value={plan} onChange={(e) => { setPlan(e.target.value); setPage(0); }} className="border border-slate-200 rounded-md px-2 py-1.5 text-sm" data-testid="sub-plan-filter">
          <option value="">Tous plans</option>
          <option value="monthly">Mensuel</option>
          <option value="yearly">Annuel</option>
        </select>
        <label className="text-sm text-slate-600 flex items-center gap-1.5 cursor-pointer">
          <input type="checkbox" checked={includeHidden} onChange={(e) => { setIncludeHidden(e.target.checked); setPage(0); }} data-testid="sub-include-hidden" />
          Inclure tests
        </label>
        <Button onClick={reload} size="sm" variant="outline" className="rounded-full" disabled={loading}>
          <RefreshCw className={`w-3 h-3 mr-1 ${loading ? "animate-spin" : ""}`} />Rafraîchir
        </Button>
        <Button onClick={exportCsv} size="sm" variant="outline" className="rounded-full ml-auto" data-testid="sub-export-csv">
          <Download className="w-3 h-3 mr-1" />Export CSV
        </Button>
      </div>

      {/* Table */}
      {loading && data.items.length === 0 ? (
        <div className="card-soft p-6 text-center text-slate-500">Chargement…</div>
      ) : data.items.length === 0 ? (
        <div className="card-soft p-8 text-center text-slate-500" data-testid="sub-empty">
          Aucun abonnement trouvé{q || status || plan ? " avec ces filtres." : "."}
        </div>
      ) : (
        <div className="card-soft overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500">
              <tr>
                <th className="text-left p-3">MNS</th>
                <th className="text-left p-3">Plan</th>
                <th className="text-left p-3">Statut</th>
                <th className="text-left p-3">Période</th>
                <th className="text-left p-3">Stripe</th>
                <th className="text-left p-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((s) => (
                <tr key={s.stripe_subscription_id || s.user_id} className="border-t hover:bg-slate-50" data-testid={`sub-row-${s.user_id}`}>
                  <td className="p-3">
                    <div className="font-medium">{s.user.name}</div>
                    <div className="text-xs text-slate-500">{s.user.email}</div>
                    {s.user.hidden && <span className="text-[10px] bg-slate-200 text-slate-600 px-1.5 rounded-full">test</span>}
                  </td>
                  <td className="p-3 text-xs">
                    <span className="bg-violet-100 text-violet-700 px-2 py-0.5 rounded-full font-medium">{s.plan === "yearly" ? "Annuel" : s.plan === "monthly" ? "Mensuel" : s.plan || "—"}</span>
                  </td>
                  <td className="p-3"><SubStatusPill status={s.status} /></td>
                  <td className="p-3 text-xs text-slate-600">
                    {s.current_period_start && <div>Début : {String(s.current_period_start).slice(0, 10)}</div>}
                    {s.current_period_end && <div>Fin : {String(s.current_period_end).slice(0, 10)}</div>}
                    {s.cancel_at_period_end && <div className="text-amber-700">Résiliation programmée</div>}
                  </td>
                  <td className="p-3 text-[10px] font-mono text-slate-500">
                    <div title={s.stripe_subscription_id}>{s.stripe_subscription_id ? `${s.stripe_subscription_id.slice(0, 12)}…` : "—"}</div>
                    <div title={s.user.stripe_customer_id || ""}>{s.user.stripe_customer_id ? `${s.user.stripe_customer_id.slice(0, 12)}…` : ""}</div>
                  </td>
                  <td className="p-3">
                    <Button size="sm" variant="outline" className="rounded-full text-xs"
                            onClick={() => resync(s.user_id)}
                            disabled={busyId === s.user_id || !s.user.stripe_customer_id}
                            data-testid={`sub-resync-${s.user_id}`}
                            title="Force-resync depuis Stripe">
                      <RefreshCw className={`w-3 h-3 mr-1 ${busyId === s.user_id ? "animate-spin" : ""}`} />Resync
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Pagination */}
      <div className="flex items-center justify-between gap-3 flex-wrap text-sm">
        <div className="flex items-center gap-2">
          <Label className="text-xs">Par page</Label>
          <select value={pageSize} onChange={(e) => { setPageSize(parseInt(e.target.value, 10)); setPage(0); }}
                  className="border border-slate-200 rounded-md px-2 py-1 text-sm" data-testid="sub-page-size">
            {[20, 50, 100, 200].map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
          <span className="text-slate-500 text-xs">{data.total || 0} résultat(s)</span>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" className="rounded-full" disabled={page === 0} onClick={() => setPage((p) => Math.max(0, p - 1))} data-testid="sub-prev">← Précédent</Button>
          <span className="text-slate-500 text-xs px-2">Page {page + 1} / {totalPages}</span>
          <Button variant="outline" size="sm" className="rounded-full" disabled={page >= totalPages - 1} onClick={() => setPage((p) => p + 1)} data-testid="sub-next">Suivant →</Button>
        </div>
      </div>
    </div>
  );
}

